/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any };
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any };
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any };
};

/** Achievement status with user progress */
export type Achievement = {
  __typename?: "Achievement";
  /**
   * User's current achievement tier
   * Zero (`0`) value indicates user has not received the achievement yet
   */
  currentTier: Scalars["Int"]["output"];
  /** ID of achievement */
  id: AchievementType;
  /**
   * Target progress value for the next tier of achievement
   * Value will be `null` when there's no more tiers to be achieved
   */
  nextTierTarget?: Maybe<Scalars["Int"]["output"]>;
  /** User's overall progress towards achievement */
  progress: Scalars["Float"]["output"];
};

export type AchievementLoginReward = BaseLoginReward & {
  __typename?: "AchievementLoginReward";
  /** Amount of achievement that can be claimed */
  amount: Scalars["Int"]["output"];
  /** Status of the reward */
  claimStatus: LoginRewardStatus;
  /** Type of achievement wallet */
  itemType: AchievementType;
  /** Type of wallet. Value will always be `achievement` for `AchievementLoginReward` */
  walletType: WalletType;
};

/** Denotes the type of user achievement */
export enum AchievementType {
  BattleFriendsPlayed = "battle_friends_played",
  BattleMaster = "battle_master",
  BattleStreak = "battle_streak",
  BattlesWon = "battles_won",
  BrainstormBlitz = "brainstorm_blitz",
  CasualCrusher = "casual_crusher",
  Challenger = "challenger",
  Completionist = "completionist",
  FacedOff = "faced_off",
  FilmBuff = "film_buff",
  Followers = "followers",
  GameGrinder = "game_grinder",
  Gamer = "gamer",
  Grinder = "grinder",
  KnightJourney = "knight_journey",
  Librarian = "librarian",
  LoginStreak = "login_streak",
  TimePlayed = "time_played",
  TournamentsParticipation = "tournaments_participation",
  UnlockThePower = "unlock_the_power",
  WeeklyGlParticipant = "weekly_gl_participant",
  WeeklyGlWinner = "weekly_gl_winner",
}

export type AchievementUserNotificationData = {
  __typename?: "AchievementUserNotificationData";
  /** Achievement balance that user got */
  balance: Scalars["Int"]["output"];
  /** Value to enable or disable achievement notification */
  isEndScreenReward: Scalars["Boolean"]["output"];
  /** Achievement type that user got */
  type: AchievementType;
};

export type AchievementsInput = {
  /** DEPRECATED: Not being used anymore */
  products?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AchievementsOutput = PaginatedQueryOutput & {
  __typename?: "AchievementsOutput";
  items: Array<Achievement>;
  total: Scalars["Int"]["output"];
};

export type ActivitiesInput = {
  /** Name of the category of which activities to be listed */
  category?: InputMaybe<ActivityCategory>;
  /** Filters of the category to be listed */
  filters?: InputMaybe<ActivityCategoryFilterInput>;
  /** Pagination input */
  page?: InputMaybe<PaginatedQueryInput>;
  /** A list of product IDs to filter activities by. If omitted, activities for all products are returned. */
  products?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type Activity = {
  __typename?: "Activity";
  activityType: ActivityType;
  createdAt: Scalars["DateTimeISO"]["output"];
  data?: Maybe<ActivityData>;
  id: Scalars["String"]["output"];
  product: Product;
};

export enum ActivityCategory {
  Friends = "FRIENDS",
  Profile = "PROFILE",
}

export type ActivityCategoryFilterInput = {
  /**
   * Filters activities by specific activity types.
   * Example: To retrieve leaderboard-related activities, use `[leaderboard_ended]`.
   */
  activityTypes?: InputMaybe<Array<ActivityType>>;
  /** Filters activities by specific battle types. */
  battleTypes?: InputMaybe<Array<BattleType>>;
};

export type ActivityData =
  | BattleActivityData
  | CompleteViewContentActivityData
  | GameEndedActivityData
  | GameplayEndedActivityData
  | LeaderboardActivityData
  | LoginRewardActivityData
  | UserLeaderboardActivityData;

export type ActivityOutput = {
  __typename?: "ActivityOutput";
  items: Array<Activity>;
  total: Scalars["Int"]["output"];
};

/** Activity types for tracking */
export enum ActivityType {
  AdWatched = "ad_watched",
  BattleCancelled = "battle_cancelled",
  BattleExpired = "battle_expired",
  BattleExpiring = "battle_expiring",
  BattleFinish = "battle_finish",
  BattleInviteRejected = "battle_invite_rejected",
  BattleInviteSent = "battle_invite_sent",
  BattleInvited = "battle_invited",
  BattlePlayed = "battle_played",
  BattleQuit = "battle_quit",
  ChallengeFailed = "challenge_failed",
  ContestLeaderboardEnded = "contest_leaderboard_ended",
  FirstSteamGameplay = "first_steam_gameplay",
  GameEnded = "game_ended",
  GameSessionEnded = "game_session_ended",
  GameplayEnded = "gameplay_ended",
  LeaderboardEnded = "leaderboard_ended",
  LoggedIn = "logged_in",
  LoginReward = "login_reward",
  NewFollower = "new_follower",
  SubscriptionActivated = "subscription_activated",
  SubscriptionBonusGranted = "subscription_bonus_granted",
  SubscriptionOrderFulfilled = "subscription_order_fulfilled",
  SystemLeaderboardEnded = "system_leaderboard_ended",
  SystemLeaderboardReminder = "system_leaderboard_reminder",
  SystemTournamentEnded = "system_tournament_ended",
  TieredReward = "tiered_reward",
  TournamentDemotion = "tournament_demotion",
  UserLeaderboardEnded = "user_leaderboard_ended",
  UserUnfollowed = "user_unfollowed",
  UserUpdate = "user_update",
  ViewContent = "view_content",
  ViewContentComplete = "view_content_complete",
}

/** Age rating information for a game */
export type AgeRating = {
  __typename?: "AgeRating";
  /** Content descriptors (e.g., Violence, Language) */
  contentDescriptors?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Age/rating value (e.g., '12', 'T', 'M') */
  rating: Scalars["String"]["output"];
  /** Rating system (PEGI, ESRB, IARC, etc.) */
  system: AgeRatingSystem;
};

/** Supported age rating systems worldwide */
export enum AgeRatingSystem {
  /** Australian Classification Board */
  Acb = "ACB",
  /** Computer Entertainment Rating Organization (Japan) */
  Cero = "CERO",
  /** Brazilian Advisory Rating (Brazil) */
  ClassInd = "CLASS_IND",
  /** Entertainment Software Rating Board (North America) */
  Esrb = "ESRB",
  /** Game Rating and Administration Committee (South Korea) */
  Grac = "GRAC",
  /** International Age Rating Coalition */
  Iarc = "IARC",
  /** Pan European Game Information (Europe) */
  Pegi = "PEGI",
  /** Unterhaltungssoftware Selbstkontrolle (Germany) */
  Usk = "USK",
}

export type ApplyInventoryInput = {
  /** ID of the inventory to apply to the user */
  inventoryId: Scalars["UUID"]["input"];
};

export type BaseLoginReward = {
  amount: Scalars["Int"]["output"];
  claimStatus: LoginRewardStatus;
  walletType: WalletType;
};

export type BattleActivityData = {
  __typename?: "BattleActivityData";
  /** Id of the battle */
  battleId: Scalars["String"]["output"];
  /** Type of battle */
  battleType: BattleType;
  /** Game info of the battle */
  game: Game;
  /** Moment used in battle or null */
  moment?: Maybe<Moment>;
  /** Opponent Users in the battle */
  opponentUsers: Array<User>;
  /** Prize awarded to the user for the battle. Provided only in battle_finish activity type. */
  prize?: Maybe<BattleActivityPrize>;
  /** User's Rank in tournament, house battle, or battle. Provided only for battle_finish, battle_played activity types. */
  rank?: Maybe<Scalars["Int"]["output"]>;
  /** Time played in seconds. Provided only in battle_finish activity type. */
  timePlayed?: Maybe<Scalars["Int"]["output"]>;
  /** Provided only in battle_finish activity, depicting if the user won or not */
  winner?: Maybe<Scalars["Boolean"]["output"]>;
};

export type BattleActivityPrize = {
  __typename?: "BattleActivityPrize";
  /** Amount of coin awarded as prize */
  amount: Scalars["Float"]["output"];
  /** Type of coin awarded as prize */
  coinType: CoinType;
};

/** Denotes the Battle payout data */
export type BattlePayout = {
  __typename?: "BattlePayout";
  /** Currency to be used for Battle Payout */
  coinType: CoinType;
  /** Prize value for the loser (toRank = 2) */
  coinsLoser: Scalars["Int"]["output"];
  /** Prize value for the winner (toRank = 1) */
  coinsWinner: Scalars["Int"]["output"];
};

export type BattleStreak = {
  __typename?: "BattleStreak";
  /** The best recorded battle streak value. */
  best: Scalars["Int"]["output"];
  /** The current battle streak value. */
  current: Scalars["Int"]["output"];
};

export enum BattleType {
  /** Gameplay modes */
  CasualHtml = "CASUAL_HTML",
  CasualStream = "CASUAL_STREAM",
  Challenge = "CHALLENGE",
  FriendBattle = "FRIEND_BATTLE",
  // HouseBattle = "HOUSE_BATTLE",
  // Tournament = "TOURNAMENT",
  Battle = "battle",
  HouseBattle = "house_battle",
  Solo = "solo",
  /** Legacy battle types */
  Tournament = "tournament",
}

/** Data for battle notifications */
export type BattleUserNotificationData = {
  __typename?: "BattleUserNotificationData";
  /** Datetime at which the battle will expire, can be null for certain battle notifications */
  expiryTime?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /** Game ID */
  gameId: Scalars["String"]["output"];
  /** User informations about the host. Returns null if user is disabled or not found */
  host?: Maybe<User>;
  /** Match ID */
  matchId: Scalars["UUID"]["output"];
  /** Match State */
  matchState: MatchState;
  /** User information about the opponent. Returns null if user is disabled or not found */
  opponent?: Maybe<User>;
};

export type BillingInfo = {
  __typename?: "BillingInfo";
  name?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
};

export type BillingInfoInput = {
  name: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
};

export type BlacknutStreamLaunchData = {
  __typename?: "BlacknutStreamLaunchData";
  /** User access token for Blacknut */
  accessToken: Scalars["String"]["output"];
  /** Blacknut Game ID that is needed by Blacknut SDK to launch the game */
  blacknutGameId: Scalars["String"]["output"];
  /** User refresh token for Blacknut */
  refreshToken: Scalars["String"]["output"];
};

export enum BucketType {
  Assets = "assets",
  Data = "data",
}

/** Input type for canceling a subscription. By default, the subscription will remain active until the end of the current billing cycle, but if 'cancelImmediately' is set to true, the subscription will be canceled immediately. */
export type CancelSubscriptionInput = {
  /** If true, subscription is canceled immediately. If false (default), stays active until current cycle ends */
  cancelImmediately?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Reason for canceling the subscription */
  reason: Scalars["String"]["input"];
};

export type CasualHtmlLaunchData = {
  __typename?: "CasualHtmlLaunchData";
  /** The configuration for the game to be launched */
  gameConfig: Scalars["JSON"]["output"];
  /** The URL to launch the game in casual HTML mode */
  launchUrl: Scalars["String"]["output"];
};

/** Denotes the casual game mode payout configuration */
export type CasualPayout = {
  __typename?: "CasualPayout";
  /** Currency to be used for casual rewards */
  coinType: CoinType;
  /** Gems earned per minute of play */
  coinsPerMinute: Scalars["Int"]["output"];
  /** Maximum gems that can be earned per session */
  maxCoinsPerSession: Scalars["Int"]["output"];
};

export type CasualStreamConfigInput = {
  /** The cluster details calculated from FE like ping, jitter, packet loss etc., required only for `PC_STREAM` game type by the EON APIs. */
  clientClusterMetrics?: InputMaybe<Array<ClusterMetricsInput>>;
  /** The client/cluster ID to use for the casual stream game mode required only for `PC_STREAM_DEMO` game type by the EON APIs. */
  clusterId?: InputMaybe<Scalars["String"]["input"]>;
  /** The URL of the cluster to use for the casual stream game mode required only for `N2I_STREAM` game type. */
  clusterUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** The stream codec to use for the PC_STREAM game type. Defaults to H264 if not provided. */
  codec?: InputMaybe<StreamCodec>;
};

/** Denotes the rewards for a challenge */
export type ChallengeRewards = {
  __typename?: "ChallengeRewards";
  /** Currency to be used for Challenge rewards */
  coinType: CoinType;
  /** Gems received when challenge is completed from the second time onwards */
  coinsCompletion: Scalars["Int"]["output"];
  /** Gems received when user fails to complete a challenge */
  coinsFailure: Scalars["Int"]["output"];
  /** Gems received when challenge is completed for the first time */
  coinsFirstTimeCompletion: Scalars["Int"]["output"];
};

export type ClearNotificationsInput = {
  /** List of notification IDs to clear. If not provided, all notifications will be cleared */
  notificationIds?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  /** Product ID to filter notifications. If not provided, all notifications from all products will be cleared */
  product?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClusterMetricsInput = {
  /** The metrics to the cluster, ping only for now */
  metrics?: InputMaybe<Array<ClusterStatInput>>;
  /** Cluster Name */
  name: Scalars["String"]["input"];
  /** Boolean indicating if the cluster is reachable from the client */
  reachable: Scalars["Boolean"]["input"];
};

export type ClusterStatInput = {
  ping?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CoinLoginReward = BaseLoginReward & {
  __typename?: "CoinLoginReward";
  /** Amount of coins that can be claimed */
  amount: Scalars["Int"]["output"];
  /** Status of the reward */
  claimStatus: LoginRewardStatus;
  /** Type of coin wallet */
  itemType: CoinType;
  /** Type of wallet. Value will always be `coin` for `CoinLoginReward` */
  walletType: WalletType;
};

export enum CoinType {
  Basic = "basic",
  Gems = "gems",
  GzTokens = "gz_tokens",
  SpendableGems = "spendable_gems",
  SpendableGzTokens = "spendable_gz_tokens",
  Vodabucks = "vodabucks",
}

/** Denotes a coin wallet */
export type CoinWallet = {
  __typename?: "CoinWallet";
  /** Coin balance */
  balance: Scalars["Int"]["output"];
  /** Coin type */
  itemType: CoinType;
  /** User Id */
  userId: Scalars["String"]["output"];
  /** Wallet Type */
  walletType: WalletType;
};

export type CompleteContentInput = {
  contentId: Scalars["UUID"]["input"];
};

export type CompleteViewContentActivityData = {
  __typename?: "CompleteViewContentActivityData";
  contentType: Scalars["String"]["output"];
};

export type Config = {
  __typename?: "Config";
  /** Free coins that can be claimed by the user */
  freeCoins?: Maybe<FreeCoins>;
  /** Prize pools for battles and challenges */
  prizePools: PrizePools;
  /** Tier Levels */
  tierLevels: Array<TierLevel>;
};

export type CreateEventRuleInput = {
  active: Scalars["Boolean"]["input"];
  filters?: InputMaybe<Scalars["JSONObject"]["input"]>;
  parameters?: InputMaybe<Scalars["JSONObject"]["input"]>;
  ruleType: Scalars["String"]["input"];
  synchronous: Scalars["Boolean"]["input"];
};

export type CreateProductInput = {
  /** Configuration of the product */
  config: Scalars["JSON"]["input"];
  /** ID of the product */
  id: Scalars["String"]["input"];
  /** Name of the product */
  name: Scalars["String"]["input"];
  /** 2-letter unique shortcode for the product */
  shortCode: Scalars["String"]["input"];
  /** Supported game modes for the product */
  supportedGameModes: Array<GamePlayMode>;
  /** Type of the product */
  type: ProductType;
};

export type CreateTenantInput = {
  /** Overridden Game IDs */
  gameOverrideIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Game Override type */
  gameOverrideMode?: InputMaybe<GameOverrideMode>;
  /**
   * ID of the tenant
   * Format: `{tenant_name}{country_code}`
   * - `{tenant_name}` should be name of the tenant. Ex: `dialog`
   * - `{country_code} should in ISO 3166-1 alpha-2 format. Ex: `lk`
   * - Example: `dialoglk`
   */
  id: Scalars["String"]["input"];
  /** Default language code of the tenant. Defaults to `en` */
  languageCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Additional metadata for the tenant */
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /**
   * Name of the tenant
   * Recommended Format: `FriendlyTenantName FriendlyCountryName`
   * Example: `Dialog Sri Lanka`
   */
  name: Scalars["String"]["input"];
  /** Enabled products for the tenant */
  products: Array<TenantProductConfigInput>;
  /**
   * Short name for the tenant
   * - Restricted to 3 characters
   * - Example: `dgl`, `vil`, etc.
   */
  shortCode: Scalars["String"]["input"];
  /** Tenant status which indicates if tenant is live or is disabled. Defaults to LIVE */
  status?: InputMaybe<TenantStatus>;
};

/** Input type for creating vouchers */
export type CreateVouchersInput = {
  /** Number of voucher codes to generate */
  count: Scalars["Int"]["input"];
  /** Optional expiration date for the vouchers (ISO 8601 format) */
  expiresAt?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  /** Optional metadata for the vouchers */
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /** ID of the subscription plan these vouchers grant access to */
  planId: Scalars["UUID"]["input"];
  /** Serial number prefix for grouping vouchers by controller (format: [productCode][year][batch], e.g. AA2601) */
  serialNumberPrefix: Scalars["String"]["input"];
};

/** Response for voucher creation */
export type CreateVouchersOutput = {
  __typename?: "CreateVouchersOutput";
  /** Batch ID for the created vouchers */
  batchId: Scalars["String"]["output"];
  /** List of generated voucher codes (formatted with dashes) */
  codes: Array<Scalars["String"]["output"]>;
  /** Total number of vouchers created */
  count: Scalars["Int"]["output"];
};

/** Input for crediting items to a user's wallet by ADMIN/B2B_ADMIN */
export type CreditItemsInput = {
  /** Amount to credit (must be positive) */
  amount: Scalars["Float"]["input"];
  /** Specific item type within the wallet (e.g., basic, gems, gz_tokens) */
  itemType: Scalars["String"]["input"];
  /** User ID to credit items to */
  userId: Scalars["UUID"]["input"];
  /** Type of wallet to credit items to */
  walletType: WalletType;
};

/** Input for debiting items from a user's wallet by ADMIN/B2B_ADMIN */
export type DebitItemsInput = {
  /** Amount to debit (must be positive) */
  amount: Scalars["Float"]["input"];
  /** Specific item type within the wallet (e.g., basic, gems, GZ_TOKENS) */
  itemType: Scalars["String"]["input"];
  /** User ID to debit items for */
  userId: Scalars["UUID"]["input"];
  /** Type of wallet to debit items from */
  walletType: WalletType;
};

/** Input for deleting all featured cards for a tenant and product */
export type DeleteFeaturedCardsInput = {
  /** Product ID */
  productId: Scalars["String"]["input"];
  /** Tenant ID */
  tenantId: Scalars["String"]["input"];
};

/** Input for deleting all pages for a tenant and product */
export type DeletePagesInput = {
  /** Product ID */
  productId: Scalars["String"]["input"];
  /** Tenant ID */
  tenantId: Scalars["String"]["input"];
};

export type DeviceInfoInput = {
  /** Device Maker (e.g. Apple, Samsung) */
  make: Scalars["String"]["input"];
  /** Device Model (e.g. iPhone 12, Galaxy S21) */
  model: Scalars["String"]["input"];
  /** Device OS */
  os: Scalars["String"]["input"];
  /** Device Resolution (e.g 1080) */
  resolution: Scalars["Int"]["input"];
  /** Device Type (e.g. mobile, tv) */
  type: DeviceType;
};

export enum DeviceType {
  DesktopNative = "DESKTOP_NATIVE",
  DesktopWeb = "DESKTOP_WEB",
  MobileNative = "MOBILE_NATIVE",
  MobileWeb = "MOBILE_WEB",
  TabletNative = "TABLET_NATIVE",
  TabletWeb = "TABLET_WEB",
  Tv = "TV",
  Unknown = "UNKNOWN",
}

export type DisconnectStreamInput = {
  /** The game session ID of the active stream to disconnect */
  gameSessionId: Scalars["UUID"]["input"];
};

export type DisconnectStreamOutput = {
  __typename?: "DisconnectStreamOutput";
  /** Message indicating the result of the disconnect operation */
  message: Scalars["String"]["output"];
};

/** Input for duplicating featured cards between tenants */
export type DuplicateFeaturedCardsInput = {
  /** Product ID (same for source and target) */
  productId: Scalars["String"]["input"];
  /** Source tenant ID */
  sourceTenantId: Scalars["String"]["input"];
  /** Target tenant ID */
  targetTenantId: Scalars["String"]["input"];
};

/** Input for duplicating pages between tenants */
export type DuplicatePagesInput = {
  /** Product ID (same for source and target) */
  productId: Scalars["String"]["input"];
  /** Source tenant ID */
  sourceTenantId: Scalars["String"]["input"];
  /** Target tenant ID */
  targetTenantId: Scalars["String"]["input"];
};

export type EndGamePlayInput = {
  /** Game session ID to end the game play */
  gameSessionId: Scalars["UUID"]["input"];
  /** Total seconds the user experienced poor network during the session */
  poorNetworkSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  /** The score achieved in the game session */
  score: Scalars["Float"]["input"];
  /** To indicate what happened to the game session when ending the game play */
  status: GameSessionInputStatus;
  /** Time spent in the game session in seconds */
  time: Scalars["Int"]["input"];
};

export type EndGamePlayOutput = {
  __typename?: "EndGamePlayOutput";
  gameParticipant: GameParticipant;
  gamePlay: GamePlay;
  gameSession: GameSession;
};

export enum EonAccountProvider {
  Steam = "STEAM",
}

export type EonClusterDomain = {
  __typename?: "EonClusterDomain";
  domain: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type EonLinkedAccount = {
  __typename?: "EonLinkedAccount";
  provider: EonAccountProvider;
  status: EonLinkingStatus;
};

export enum EonLinkingStatus {
  Linked = "LINKED",
  NotLinked = "NOT_LINKED",
}

export type EpayInventoryCost = {
  __typename?: "EpayInventoryCost";
  amount: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
};

export type EventRule = {
  __typename?: "EventRule";
  active: Scalars["Boolean"]["output"];
  createdAt: Scalars["DateTimeISO"]["output"];
  filters?: Maybe<Scalars["JSONObject"]["output"]>;
  id: Scalars["UUID"]["output"];
  parameters?: Maybe<Scalars["JSONObject"]["output"]>;
  ruleType: Scalars["String"]["output"];
  synchronous: Scalars["Boolean"]["output"];
  updatedAt: Scalars["DateTimeISO"]["output"];
};

/** Represents a featured card. */
export type FeaturedCard = {
  __typename?: "FeaturedCard";
  /** Language-specific assets (image1X, image2X, image3X, video, icon) for the featured card */
  assets: Scalars["JSON"]["output"];
  /** The creation date time of the featured card */
  createdAt: Scalars["DateTimeISO"]["output"];
  /** Data that determines the behavior of the featured card */
  data: FeaturedCardData;
  /** The start date time of the featured card */
  endDate?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /**
   * Group to which the featured card belongs, allowing categorization and having multiple sets of featured cards.
   * Defaults to `main` if not specified.
   */
  group: Scalars["String"]["output"];
  /** Unique identifier for the featured card, typically a UUID */
  id: Scalars["UUID"]["output"];
  /**
   * Multilingual image URLs for the featured card, where keys represent language codes
   * @deprecated Use `assets` field instead
   */
  imageUrl?: Maybe<Scalars["JSON"]["output"]>;
  /** Type of link associated with the featured card (e.g., internal, external, promotional) */
  linkType: LinkType;
  /** Additional metadata for the featured card (e.g., chargeType, internalProduct) */
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  /** Ordering position of the featured card in a list or display sequence */
  position: Scalars["Int"]["output"];
  /** The start date time of the featured card */
  startDate?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /** Language-specific titles for the featured card */
  title?: Maybe<Scalars["JSON"]["output"]>;
  /** The updation date time of the featured card */
  updatedAt: Scalars["DateTimeISO"]["output"];
};

export type FeaturedCardData =
  | GameFeaturedCardData
  | LinkFeaturedCardData
  | PathFeaturedCardData
  | TournamentFeaturedCardData;

/** Input for featuredCardGroups query */
export type FeaturedCardGroupsInput = {
  /** Product ID */
  productId: Scalars["String"]["input"];
  /** Tenant ID */
  tenantId: Scalars["String"]["input"];
};

/** Input type of Featured Cards */
export type FeaturedCardInput = {
  /** Language-specific assets (image1X, image2X, image3X, video, icon) */
  assets: Scalars["JSON"]["input"];
  /** End date and time */
  endDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  /** Type of link (e.g., internal, external) */
  linkType: Scalars["String"]["input"];
  /** Additional metadata (e.g., chargeType, internalProduct) */
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Display position in a list */
  position: Scalars["Int"]["input"];
  /** URL to redirect upon click */
  redirectUrl: Scalars["String"]["input"];
  /** Start date and time */
  startDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  /** Language-specific titles */
  title?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type FeaturedCardOutput = PaginatedQueryOutput & {
  __typename?: "FeaturedCardOutput";
  /**
   * Groups that have featured cards defined
   * @deprecated Use `featuredCardGroups` query instead
   */
  groups: Array<Scalars["String"]["output"]>;
  /** List of featured cards */
  items: Array<FeaturedCard>;
  /**
   * Tenants that have featured cards defined
   * @deprecated Use `featuredCardTenants` query instead
   */
  tenants: Array<Tenant>;
  /** Total number of featured cards that exist for the given input filters */
  total: Scalars["Int"]["output"];
};

/**
 * When query input is not provided, tenantId and productId will be extracted
 * from user's auth context and only active cards will be returned.
 */
export type FeaturedCardQueryInput = {
  /** Group of featured cards to fetch. If not provided, defaults to `main`. */
  group?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by product ID.
   * If not provided, will use product ID from user's auth context.
   * However, if provided, then tenantId must also be provided.
   */
  productId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by tenant ID.
   * If not provided, will use tenant ID from user's auth context.
   * However, if provided, then productId must also be provided.
   */
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type FollowRequest = {
  __typename?: "FollowRequest";
  /** ID of the follow request */
  id: Scalars["UUID"]["output"];
  /** User Object. Null if user is disabled or not found */
  user?: Maybe<User>;
};

export enum FollowStatus {
  FollowedBy = "FOLLOWED_BY",
  Following = "FOLLOWING",
  FollowingAndFollowedBy = "FOLLOWING_AND_FOLLOWED_BY",
  NoFollow = "NO_FOLLOW",
}

export type FollowSuggestion = {
  __typename?: "FollowSuggestion";
  criteria: FollowSuggestionCriteria;
  user: User;
};

export enum FollowSuggestionCriteria {
  FollowerOfFollower = "follower_of_follower",
  LeaderboardWinner = "leaderboard_winner",
  MostActive = "most_active",
  PreviousOpponent = "previous_opponent",
}

/** Data for follow notifications */
export type FollowUserNotificationData = {
  __typename?: "FollowUserNotificationData";
  /** User doing the following. Returns null if user is disabled or not found */
  followerUser?: Maybe<User>;
};

export type FollowUsersInput = {
  page?: InputMaybe<PaginatedQueryInput>;
};

export type FollowUsersOutput = PaginatedQueryOutput & {
  __typename?: "FollowUsersOutput";
  items: Array<FollowRequest>;
  total: Scalars["Int"]["output"];
};

export type FreeCoins = {
  __typename?: "FreeCoins";
  /** Amount of free coins that can be claimed */
  amount: Scalars["Int"]["output"];
  /** Currency in which the free coins would be given in */
  coinType: CoinType;
};

export type Game = {
  __typename?: "Game";
  /** Age ratings for different rating systems (PEGI, ESRB, IARC, etc.) */
  ageRatings?: Maybe<Array<AgeRating>>;
  /** Category of the game */
  category: Scalars["String"]["output"];
  /**
   * Dynamic metadata which gives additional information about the game
   * @deprecated Data field is deprecated, use metadata instead
   */
  data?: Maybe<Scalars["String"]["output"]>;
  /** The description of the game */
  description: Scalars["String"]["output"];
  /** Developer of the game */
  developer?: Maybe<Scalars["String"]["output"]>;
  /** Indicates if the game is featured game */
  featured: Scalars["Boolean"]["output"];
  /** Indicates if the game has a BATTLE type moment */
  hasBattle: Scalars["Boolean"]["output"];
  /** Indicates if the user has played this game before. */
  hasPlayed: Scalars["Boolean"]["output"];
  /** Indicates if the game has a CASUAL type moment */
  hasSolo: Scalars["Boolean"]["output"];
  /** Indicates if the game has a OPEN status tournament */
  hasTournament: Scalars["Boolean"]["output"];
  /** Unique identifier for the game */
  id: Scalars["String"]["output"];
  /** Asset information for a game */
  metadata?: Maybe<Scalars["String"]["output"]>;
  /** Orientation of the game */
  orientation: RotationMode;
  /**
   * Pan European Game Information (PEGI) rating
   * @deprecated Use ageRatings instead
   */
  pegiAge?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Pan European Game Information (PEGI) content descriptor
   * @deprecated Use ageRatings instead
   */
  pegiContent?: Maybe<Scalars["String"]["output"]>;
  /** Publisher of the game */
  publisher?: Maybe<Scalars["String"]["output"]>;
  /**
   * Mode of rotation for the game
   * @deprecated Use orientation instead
   */
  rotationMode?: Maybe<RotationMode>;
  /** Current status of the game */
  status: GameStatus;
  /** The title of the game */
  title: Scalars["String"]["output"];
  /** Type of the game */
  type: GameType;
};

export enum GameCategory {
  Byog = "BYOG",
  Pid = "PID",
}

export type GameEndedActivityData = {
  __typename?: "GameEndedActivityData";
  timePlayed: Scalars["Int"]["output"];
};

export type GameFeaturedCardData = {
  __typename?: "GameFeaturedCardData";
  /** Game details associated with the featured card */
  game: Game;
};

export type GameInstallationProgress = {
  __typename?: "GameInstallationProgress";
  /** Installation progress percentage (0-100) for the game session. 100 indicates that the game is fully installed and ready to play. */
  progress: Scalars["Int"]["output"];
};

/** Game mode specific configuration data */
export type GameModeDataInput = {
  /**
   * Params required to launch a game in CASUAL_HTML mode.
   * Currently no additional params are required, so the only accepted value is an empty object - `{}`.
   */
  casualHtmlConfig?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Params required to launch a game in CASUAL_STREAM mode */
  casualStreamConfig?: InputMaybe<CasualStreamConfigInput>;
};

export enum GameOverrideMode {
  Exclude = "EXCLUDE",
  Include = "INCLUDE",
}

export type GameParticipant = {
  __typename?: "GameParticipant";
  /** Unique identifier for the game participant */
  id: Scalars["UUID"]["output"];
  /** The prizes won by the game participant */
  prize?: Maybe<Array<GameParticipantPrize>>;
  /** The status of the game participant */
  status: GameParticipantStatus;
};

export type GameParticipantPrize = {
  __typename?: "GameParticipantPrize";
  /** The amount of the prize */
  amount: Scalars["Float"]["output"];
  /** The item type for the prize */
  itemType: Scalars["String"]["output"];
  /** The wallet type for the prize */
  walletType: WalletType;
};

export enum GameParticipantStatus {
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Created = "CREATED",
  Played = "PLAYED",
  Playing = "PLAYING",
  Quit = "QUIT",
  Refunded = "REFUNDED",
}

export type GamePlay = {
  __typename?: "GamePlay";
  /** The game associated with this game play */
  game: Game;
  /** Unique identifier for the game play */
  id: Scalars["UUID"]["output"];
  /** The mode of the game play */
  mode: GamePlayMode;
  /** The moment associated with this game play, if any */
  moment?: Maybe<Moment>;
  /** Provider Game ID */
  providerGameId?: Maybe<Scalars["String"]["output"]>;
  /** The status of the game play */
  status: GamePlayStatus;
};

export enum GamePlayMode {
  CasualHtml = "CASUAL_HTML",
  CasualStream = "CASUAL_STREAM",
  Challenge = "CHALLENGE",
  FriendBattle = "FRIEND_BATTLE",
  HouseBattle = "HOUSE_BATTLE",
  Tournament = "TOURNAMENT",
}

export enum GamePlayStatus {
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Created = "CREATED",
}

export type GameQueue = {
  __typename?: "GameQueue";
  /** The current length of the game queue */
  length: Scalars["Int"]["output"];
  /** User's position in the game queue. 0-based ranking */
  position: Scalars["Int"]["output"];
  /** Estimated wait time in seconds for the user to start the game play */
  waitTimeSeconds: Scalars["Int"]["output"];
};

export enum GameQueueStatusEnum {
  /** Game session has been created, awaiting user to join the session */
  Completed = "COMPLETED",
  /** User is still in queue waiting for resources */
  Queued = "QUEUED",
}

export type GameQueueStatusOutput = {
  __typename?: "GameQueueStatusOutput";
  /** Queue information if status is QUEUED */
  gameQueue?: Maybe<GameQueue>;
  /** Current status of the queue request */
  status: GameQueueStatusEnum;
};

export enum GameSearchStatus {
  /** The query matched a label on a game, but not an exact title */
  LabelMatchFound = "LABEL_MATCH_FOUND",
  /** The queried game exists in the index and is currently playable */
  MatchFound = "MATCH_FOUND",
  /** The queried game exists in the index but not currently playable; discovery-only status / tenant restrictions */
  MatchFoundNotPlayable = "MATCH_FOUND_NOT_PLAYABLE",
  /** Status could not be determined (e.g. paginated results beyond page 1 or game list results) */
  NotApplicable = "NOT_APPLICABLE",
  /** No game matched the query by title or label */
  NotFound = "NOT_FOUND",
}

export type GameSession = {
  __typename?: "GameSession";
  /** The game associated with this game play */
  game: Game;
  /** Unique identifier for the game session */
  id: Scalars["UUID"]["output"];
  /** The launcher information for the game play */
  launchData?: Maybe<LaunchData>;
  /** The status of the game session */
  status: GameSessionStatus;
};

export type GameSessionInput = {
  /** Unique identifier for the game session */
  id: Scalars["UUID"]["input"];
};

export enum GameSessionInputStatus {
  Completed = "COMPLETED",
  Quit = "QUIT",
  StreamError = "STREAM_ERROR",
}

export enum GameSessionStatus {
  Closed = "CLOSED",
  Created = "CREATED",
  Playing = "PLAYING",
}

export enum GameStatus {
  Disabled = "DISABLED",
  DiscoveryOnly = "DISCOVERY_ONLY",
  Draft = "DRAFT",
  Live = "LIVE",
}

export type GameSuggestionsInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: Scalars["String"]["input"];
};

export enum GameType {
  BlacknutStream = "BLACKNUT_STREAM",
  DirectHtml = "DIRECT_HTML",
  /** @deprecated Not being used anymore */
  Embed = "EMBED",
  /** @deprecated Use specific HTML types instead */
  Html = "HTML",
  IframeHtml = "IFRAME_HTML",
  LegacyStream = "LEGACY_STREAM",
  N2IStream = "N2I_STREAM",
  PcStream = "PC_STREAM",
  PcStreamDemo = "PC_STREAM_DEMO",
  /** @deprecated Use specific stream types instead */
  Stream = "STREAM",
}

export type GameplayEndedActivityData = {
  __typename?: "GameplayEndedActivityData";
  gamePlay: GamePlay;
  rewards: Array<GameplayEndedReward>;
};

export type GameplayEndedReward = {
  __typename?: "GameplayEndedReward";
  amount: Scalars["Int"]["output"];
  itemType: Scalars["String"]["output"];
  walletType: WalletType;
};

export type GamesOutput = PaginatedQueryOutput & {
  __typename?: "GamesOutput";
  items: Array<Game>;
  /** search query status, NOT_APPLICABLE on list games */
  status: GameSearchStatus;
  total: Scalars["Int"]["output"];
};

export enum GlobalLeaderboardType {
  /** All-time global leaderboard */
  AllTime = "allTime",
  /** Daily global leaderboard */
  Daily = "daily",
  /** Monthly global leaderboard */
  Monthly = "monthly",
  /** Weekly global leaderboard */
  Weekly = "weekly",
}

export type Health = {
  __typename?: "Health";
  status: HealthStatus;
};

export enum HealthStatus {
  Error = "ERROR",
  Ok = "OK",
}

/** Input type for initiating a new purchase. */
export type InitiatePurchaseInput = {
  /** Item identifier (e.g. coin pack ID, product SKU) */
  itemId?: InputMaybe<Scalars["String"]["input"]>;
  /** subscription_plans.id — triggers SUBSCRIPTION flow (amount derived from plan) */
  planId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** URL to redirect the user back to after payment completion */
  returnUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** Result type returned after initiating a purchase, containing all necessary information for the frontend to proceed with payment. */
export type InitiatePurchaseResult = {
  __typename?: "InitiatePurchaseResult";
  /** Order amount */
  amount: Scalars["Float"]["output"];
  /** Payment gateway that handles this order (e.g. RAZORPAY, JUSPAY). FE uses this to initialize the correct payment SDK. */
  gateway: PaymentGateway;
  /** Gateway's order/session ID */
  orderId: Scalars["String"]["output"];
  /** Payment URLs for redirect-based checkout flows */
  paymentUrls?: Maybe<PaymentUrls>;
  /** SDK-specific payload for native checkout (e.g. Juspay HyperSDK) */
  sdkPayload?: Maybe<SdkPayload>;
  /** Current order status */
  status: OrderStatus;
};

export type InventoriesFilters = {
  /** UUID of the bundle inventory to list all the items of the bundle */
  bundleInventoryId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Filter by inventory categories if provided */
  categories?: InputMaybe<Array<InventoryCategory>>;
  /** Return only bundles in response */
  restrictToBundles?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Return only free items in response */
  restrictToFree?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Return only non-bundle items in response */
  restrictToItems?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter to return Inventory items with given status */
  status?: InputMaybe<Array<InventoryStatus>>;
};

/** Filters for fetching inventories. */
export type InventoriesInput = {
  /** Additional input filters */
  filters?: InputMaybe<InventoriesFilters>;
  /** Pagination input */
  page?: InputMaybe<PaginatedQueryInput>;
};

export type InventoriesOutput = PaginatedQueryOutput & {
  __typename?: "InventoriesOutput";
  items: Array<Inventory>;
  total: Scalars["Int"]["output"];
};

export type Inventory = {
  __typename?: "Inventory";
  /** Indicates whether the inventory should be applied immediately upon purchase. */
  applyImmediately: Scalars["Boolean"]["output"];
  /** Category of the inventory, categorizing it into a specific group. */
  category: InventoryCategory;
  /**
   * List of costs associated with acquiring the inventory, in different coin types.
   * @deprecated Use `prices` field instead, which includes all types of costs
   */
  costs?: Maybe<Array<Maybe<InventoryCost>>>;
  /** The timestamp when the inventory was created. */
  createdAt: Scalars["DateTimeISO"]["output"];
  /** Data associated with the inventory */
  data: InventoryData;
  /** Unique identifier for the inventory. */
  id: Scalars["UUID"]["output"];
  /** Indicates whether the inventory is a bundle consisting of multiple items. */
  isBundle: Scalars["Boolean"]["output"];
  /** Indicates if the inventory was purchased by the user */
  isPurchased: Scalars["Boolean"]["output"];
  /** Metadata associated with the inventory item */
  metadata?: Maybe<Scalars["JSONObject"]["output"]>;
  /** List of prices associated with acquiring the inventory, in different coin types and currencies. */
  prices?: Maybe<Array<Maybe<InventoryCostUnion>>>;
  /** Current status of the inventory, indicating its availability and visibility. */
  status: InventoryStatus;
  /** Title of the inventory. */
  title: Scalars["String"]["output"];
  /** The timestamp when the inventory was last updated. */
  updatedAt: Scalars["DateTimeISO"]["output"];
};

export type InventoryAvatarData = {
  __typename?: "InventoryAvatarData";
  url: Scalars["String"]["output"];
};

export type InventoryBundleData = {
  __typename?: "InventoryBundleData";
  items: Array<Scalars["String"]["output"]>;
  previewUrl: Scalars["String"]["output"];
};

export enum InventoryCategory {
  Avatar = "AVATAR",
  Epay = "EPAY",
  Mixed = "MIXED",
}

export type InventoryCost = {
  __typename?: "InventoryCost";
  amount: Scalars["Float"]["output"];
  coinType: CoinType;
};

export type InventoryCostInput = {
  amount: Scalars["Int"]["input"];
  coinType: CoinType;
};

export type InventoryCostUnion = EpayInventoryCost | InventoryCost;

export type InventoryData =
  | InventoryAvatarData
  | InventoryBundleData
  | InventoryEpayBundleData
  | InventoryEpayItemData;

export type InventoryEpayBundleData = {
  __typename?: "InventoryEpayBundleData";
  items: Array<Scalars["String"]["output"]>;
  previewUrl: Scalars["String"]["output"];
};

export type InventoryEpayItemData = {
  __typename?: "InventoryEpayItemData";
  description: Scalars["String"]["output"];
  purchaseLink: Scalars["String"]["output"];
  redeemDescription: Scalars["String"]["output"];
  shortDescription: Scalars["String"]["output"];
  termsAndConditions: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export enum InventoryStatus {
  Available = "AVAILABLE",
  Disabled = "DISABLED",
  Hidden = "HIDDEN",
  Restricted = "RESTRICTED",
}

export type JoinGamePlayInput = {
  /** The client device info */
  deviceInfo?: InputMaybe<DeviceInfoInput>;
  /** The game ID associated with the game play */
  gameId?: InputMaybe<Scalars["String"]["input"]>;
  /** The game play ID to join, if any. If not provided, a new game play will be created. */
  gamePlayId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** The game mode for the game play */
  mode?: InputMaybe<GamePlayMode>;
  /** Game mode specific configuration data */
  modeData?: InputMaybe<GameModeDataInput>;
  /** When `true` starts the game play immediately for the user, otherwise `startGamePlay` needs to be called explicitly to start the game play. Defaults to `false` when not provided. */
  startImmediately?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type JoinGamePlayOutput = {
  __typename?: "JoinGamePlayOutput";
  /** The game participant associated with the game play. Null when game play is queued. */
  gameParticipant?: Maybe<GameParticipant>;
  /** The game play that was joined or created */
  gamePlay?: Maybe<GamePlay>;
  /** The game queue information for the user if they are in a queue waiting to start the game play. */
  gameQueue?: Maybe<GameQueue>;
  /** The game session created or joined as part of the game play. Null when game play is queued. */
  gameSession?: Maybe<GameSession>;
  /**
   * The launcher information for the game play
   * @deprecated Use LaunchData under the GameSession field instead
   */
  launchData?: Maybe<LaunchData>;
  /** Message indicating the result of the join operation */
  message: Scalars["String"]["output"];
};

/** Juspay HyperSDK payload for native/SDK-based checkout */
export type JuspaySdkPayload = {
  __typename?: "JuspaySdkPayload";
  /** Full payload to pass to HyperSDK */
  payload: Scalars["JSON"]["output"];
  /** Juspay request ID for tracking */
  requestId: Scalars["String"]["output"];
  /** Juspay service identifier */
  service: Scalars["String"]["output"];
};

export type LastActive = {
  __typename?: "LastActive";
  ipAddress?: Maybe<Scalars["String"]["output"]>;
  time?: Maybe<Scalars["DateTimeISO"]["output"]>;
};

export type LaunchData =
  | BlacknutStreamLaunchData
  | CasualHtmlLaunchData
  | N2IStreamLaunchData
  | PcStreamLaunchData;

export type Leaderboard = PaginatedQueryOutput & {
  __typename?: "Leaderboard";
  /** Expiration date of leaderboard. Null for all-time global leaderboard. */
  endDate?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /** Array of top users on leaderboard. Empty if no users on leaderboard. */
  items: Array<LeaderboardUser>;
  /** Rank of logged-in user. Null if user is not on leaderboard */
  rank?: Maybe<Scalars["Int"]["output"]>;
  /** Score of logged-in user. Null if user is not on leaderboard */
  score?: Maybe<Scalars["Int"]["output"]>;
  /** Total number of users on leaderboard. */
  total: Scalars["Int"]["output"];
};

export type LeaderboardActivityData = {
  __typename?: "LeaderboardActivityData";
  endDate: Scalars["DateTimeISO"]["output"];
  leaderboardRank: Scalars["Int"]["output"];
  timeFrame?: Maybe<TimeFrame>;
  type: Scalars["String"]["output"];
};

export type LeaderboardInput = {
  /** Leaderboard type */
  globalLeaderboardType?: InputMaybe<GlobalLeaderboardType>;
  /** Leaderboard ID. Should only be used for fetching ended leaderboard. */
  leaderboardId?: InputMaybe<Scalars["String"]["input"]>;
  /** Pagination parameters. */
  page?: InputMaybe<PaginatedQueryInput>;
  /** Leaderboard event rule ID */
  ruleId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type LeaderboardUser = {
  __typename?: "LeaderboardUser";
  /** User's rank. Null if user is not on leaderboard */
  rank?: Maybe<Scalars["Int"]["output"]>;
  /** User's score. Null if user is not on leaderboard */
  score?: Maybe<Scalars["Int"]["output"]>;
  /** User profile */
  user?: Maybe<User>;
};

/** Data for leaderboard notifications */
export type LeaderboardUserNotificationData = {
  __typename?: "LeaderboardUserNotificationData";
  /** Date at which the leaderboard ends */
  endDate: Scalars["String"]["output"];
  /** Leaderboard Id. Null for legacy leaderboard system */
  leaderboardId?: Maybe<Scalars["String"]["output"]>;
  /** Type of the leaderboard i.e. weekly, monthly or contest */
  leaderboardType?: Maybe<Scalars["String"]["output"]>;
  /** Rank the user finished at */
  rank: Scalars["Int"]["output"];
  /** Score of the user. Null for legacy leaderboard system */
  score?: Maybe<Scalars["Int"]["output"]>;
  /** Time frame of the leaderboard involved */
  timeFrame?: Maybe<TimeFrame>;
};

export type LinkFeaturedCardData = {
  __typename?: "LinkFeaturedCardData";
  /** The URL that the user needs to be either redirected to or rendered in an iFrame depending on the `linkType` */
  redirectUrl: Scalars["String"]["output"];
};

export enum LinkType {
  /** External links that open a third-party webpage in an iframe */
  ExternalIframe = "external_iframe",
  /** External links that open a third-party webpage in a new window */
  ExternalWindow = "external_window",
  /** Internal game listing with game details */
  InternalGame = "internal_game",
  /** Internal paths for use within the application */
  InternalLink = "internal_link",
  /** Internal tournaments hosted in the platform */
  InternalTournament = "internal_tournament",
}

export type ListGamesInput = {
  /** Category of the game */
  category?: InputMaybe<GameCategory>;
  /** Game mode filter */
  gameModes?: InputMaybe<Array<GamePlayMode>>;
  /** Game type filter */
  gameTypes?: InputMaybe<Array<GameType>>;
  /** Indicates if the game has a battles */
  hasBattles?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Pagination parameters. */
  page?: InputMaybe<PaginatedQueryInput>;
  /** Product ID filter */
  productId?: InputMaybe<Scalars["String"]["input"]>;
  /** Search query */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Status of the required games. Required when query is not provided. */
  status?: InputMaybe<Array<GameStatus>>;
  /** Tenant ID filter */
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListProductsInput = {
  /** Search products by name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Pagination */
  page?: InputMaybe<PaginatedQueryInput>;
  /** Search products by type */
  type?: InputMaybe<ProductType>;
};

export type ListSubscriptionPlansInput = {
  /** Filter by product ID */
  productId?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by tenant ID */
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListTenantsInput = {
  /** Search tenants by name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Pagination */
  page?: InputMaybe<PaginatedQueryInput>;
};

/** Input for listing vouchers */
export type ListVouchersInput = {
  /** Filter by batch ID */
  batchId?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by voucher codes (supports dashes, spaces, case-insensitive) */
  codes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Pagination options */
  page?: InputMaybe<PaginatedQueryInput>;
  /** Filter by plan ID */
  planId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Filter by serial numbers */
  serialNumbers?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by status */
  status?: InputMaybe<VoucherStatus>;
};

export type LoginReward = AchievementLoginReward | CoinLoginReward;

export type LoginRewardActivityData = {
  __typename?: "LoginRewardActivityData";
  prizeAmount: Scalars["Int"]["output"];
  prizeCoinType: CoinType;
};

export enum LoginRewardStatus {
  Claimed = "CLAIMED",
  Unavailable = "UNAVAILABLE",
  Unclaimed = "UNCLAIMED",
}

export enum MandateStatus {
  Active = "ACTIVE",
  Authenticated = "AUTHENTICATED",
  Cancelled = "CANCELLED",
  Completed = "COMPLETED",
  Created = "CREATED",
  Expired = "EXPIRED",
  Failure = "FAILURE",
  New = "NEW",
  Paused = "PAUSED",
  Revoked = "REVOKED",
}

export enum MatchState {
  Cancelled = "CANCELLED",
  Created = "CREATED",
  Expired = "EXPIRED",
  Played = "PLAYED",
  Playing = "PLAYING",
  Refunded = "REFUNDED",
  Rejected = "REJECTED",
}

export type Message = {
  __typename?: "Message";
  message: Scalars["String"]["output"];
};

export type Moment = {
  __typename?: "Moment";
  challengeNumber?: Maybe<Scalars["Int"]["output"]>;
  data: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  momentType: MomentType;
  rankOrder?: Maybe<RankOrder>;
  showTimer?: Maybe<Scalars["Boolean"]["output"]>;
  snapshotId?: Maybe<Scalars["String"]["output"]>;
  status: MomentStatus;
  time: Scalars["Int"]["output"];
  timesPlayed: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

/** Denotes the status of the moment. */
export enum MomentStatus {
  Disabled = "DISABLED",
  Draft = "DRAFT",
  Live = "LIVE",
  Upcoming = "UPCOMING",
}

/** Denotes the type of the moment. */
export enum MomentType {
  Battle = "BATTLE",
  Casual = "CASUAL",
  Challenge = "CHALLENGE",
  Tutorial = "TUTORIAL",
  Zen = "ZEN",
}

export type Mutation = {
  __typename?: "Mutation";
  applyInventory: Message;
  /** Cancel recurring subscription */
  cancelSubscription: Message;
  /** Claim Ad Watch Reward */
  claimAdWatchReward: Message;
  /** Claim free coins if available */
  claimFreeCoins: Message;
  /** Claim login reward for the specified day */
  claimLoginReward: Message;
  clearNotifications: Message;
  completeContentView: Message;
  createEventRule: EventRule;
  createProduct: Message;
  /** Create a short url that can be shared via social apps */
  createShortUrl: ShortUrl;
  createTenant: Message;
  /** Create voucher codes for a subscription plan (STUB - returns mock data) */
  createVouchers: CreateVouchersOutput;
  creditItems: Message;
  debitItems: Message;
  /** Delete all featured card groups for a tenant and product */
  deleteFeaturedCards: Message;
  /** Delete all pages and their groups for a tenant and product, including all featured cards referenced by those groups */
  deletePages: Message;
  /** Disconnect the active stream on the current device, allowing the user to reconnect from another device */
  disconnectStream: DisconnectStreamOutput;
  /** Duplicate all featured card groups from source tenant to target tenant for the given product */
  duplicateFeaturedCards: Message;
  /** Duplicate all pages and their groups from source tenant to target tenant, including featured cards for each group */
  duplicatePages: Message;
  /** End a game play for a user */
  endGamePlay: EndGamePlayOutput;
  /** Exit the authenticated user from the game queue */
  exitGameQueue: Message;
  followUser: Message;
  generateTestLoginUrl: TestLoginUrl;
  generateUploadURL: SignedUrl;
  /** Initiate Ad Watch Reward */
  initiateAdWatchReward: Message;
  /** Initiate a purchase for a subscription plan. Gateway is determined from the plan. */
  initiatePurchase: InitiatePurchaseResult;
  /** Join or create a game play for a user */
  joinGamePlay: JoinGamePlayOutput;
  markGameAsPlayed: Message;
  purchaseInventory: Message;
  /** Redeem a voucher code (authenticated user) */
  redeemVoucher: Message;
  startContentView: ViewContentOutput;
  /** Start a game play for a user */
  startGamePlay: StartGamePlayOutput;
  trackActivity: Message;
  unfollowUser: Message;
  /** Unlink a Steam account for the user */
  unlinkEonAccount: Message;
  updateEventRule: EventRule;
  updateFeaturedCards: Message;
  updatePage: Message;
  updateProduct: Message;
  updateSetting: Message;
  updateSubscriptionPlans: Message;
  updateTenant: Message;
  updateUser: Message;
  updateUserMetadata: Message;
  /** Update voucher details (status, plan, metadata) */
  updateVouchers: UpdateVouchersOutput;
  /** Verify purchase after checkout completion. Validates the gateway signature and activates the subscription or fulfills the purchase. */
  verifyPurchase: VerifyPurchaseResult;
};

export type MutationApplyInventoryArgs = {
  input: ApplyInventoryInput;
};

export type MutationCancelSubscriptionArgs = {
  input?: InputMaybe<CancelSubscriptionInput>;
};

export type MutationClaimLoginRewardArgs = {
  day: Scalars["Int"]["input"];
};

export type MutationClearNotificationsArgs = {
  input?: InputMaybe<ClearNotificationsInput>;
};

export type MutationCompleteContentViewArgs = {
  input: CompleteContentInput;
};

export type MutationCreateEventRuleArgs = {
  input: CreateEventRuleInput;
};

export type MutationCreateProductArgs = {
  input: CreateProductInput;
};

export type MutationCreateShortUrlArgs = {
  input: ShortUrlInput;
};

export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};

export type MutationCreateVouchersArgs = {
  input: CreateVouchersInput;
};

export type MutationCreditItemsArgs = {
  input: CreditItemsInput;
};

export type MutationDebitItemsArgs = {
  input: DebitItemsInput;
};

export type MutationDeleteFeaturedCardsArgs = {
  input: DeleteFeaturedCardsInput;
};

export type MutationDeletePagesArgs = {
  input: DeletePagesInput;
};

export type MutationDisconnectStreamArgs = {
  input: DisconnectStreamInput;
};

export type MutationDuplicateFeaturedCardsArgs = {
  input: DuplicateFeaturedCardsInput;
};

export type MutationDuplicatePagesArgs = {
  input: DuplicatePagesInput;
};

export type MutationEndGamePlayArgs = {
  input: EndGamePlayInput;
};

export type MutationFollowUserArgs = {
  userId: Scalars["UUID"]["input"];
};

export type MutationGenerateTestLoginUrlArgs = {
  input: TestLoginUrlInput;
};

export type MutationGenerateUploadUrlArgs = {
  input: SignedUrlInput;
};

export type MutationInitiatePurchaseArgs = {
  input: InitiatePurchaseInput;
};

export type MutationJoinGamePlayArgs = {
  input: JoinGamePlayInput;
};

export type MutationMarkGameAsPlayedArgs = {
  gameId: Scalars["String"]["input"];
};

export type MutationPurchaseInventoryArgs = {
  input: PurchaseInventoryInput;
};

export type MutationRedeemVoucherArgs = {
  input: RedeemVoucherInput;
};

export type MutationStartContentViewArgs = {
  input: ViewContentInput;
};

export type MutationStartGamePlayArgs = {
  input: StartGamePlayInput;
};

export type MutationTrackActivityArgs = {
  input: TrackActivityInput;
};

export type MutationUnfollowUserArgs = {
  userId: Scalars["UUID"]["input"];
};

export type MutationUnlinkEonAccountArgs = {
  provider?: EonAccountProvider;
};

export type MutationUpdateEventRuleArgs = {
  id: Scalars["UUID"]["input"];
  input: UpdateEventRuleInput;
};

export type MutationUpdateFeaturedCardsArgs = {
  input: UpdateFeaturedCardsInput;
};

export type MutationUpdatePageArgs = {
  input: UpdatePagesInput;
};

export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};

export type MutationUpdateSettingArgs = {
  input: SettingUpdateInput;
};

export type MutationUpdateSubscriptionPlansArgs = {
  input: UpdateSubscriptionPlansInput;
};

export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};

export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
};

export type MutationUpdateUserMetadataArgs = {
  input: UserMetadataInput;
};

export type MutationUpdateVouchersArgs = {
  input: UpdateVouchersInput;
};

export type MutationVerifyPurchaseArgs = {
  input: VerifyPurchaseInput;
};

export type N2IStreamLaunchData = {
  __typename?: "N2IStreamLaunchData";
  /** The URL to launch the game in N2I stream mode */
  launchUrl: Scalars["String"]["output"];
  /** The session ID of the N2I session */
  sessionId: Scalars["String"]["output"];
};

export type News = {
  __typename?: "News";
  /** Author of the article (may be null). */
  author?: Maybe<Scalars["String"]["output"]>;
  /** Category of the article. */
  category?: Maybe<Scalars["String"]["output"]>;
  /** Short description or excerpt for the article. */
  description?: Maybe<Scalars["String"]["output"]>;
  /** URL of an image associated with the article (if available). */
  image?: Maybe<Scalars["String"]["output"]>;
  /** Language code of the article (2-letter). */
  language?: Maybe<Scalars["String"]["output"]>;
  /** ISO 8601 timestamp when the article was published. */
  publishedDate: Scalars["DateTimeISO"]["output"];
  /** Source or publisher name. */
  source: Scalars["String"]["output"];
  /** Article title. */
  title: Scalars["String"]["output"];
  /** URL of the original article. */
  url: Scalars["String"]["output"];
};

export type NewsOutput = PaginatedQueryOutput & {
  __typename?: "NewsOutput";
  items: Array<News>;
  total: Scalars["Int"]["output"];
};

export type NewsQueryInput = {
  categories?: InputMaybe<Array<Scalars["String"]["input"]>>;
  languages?: InputMaybe<Array<Scalars["String"]["input"]>>;
  page?: InputMaybe<PaginatedQueryInput>;
  sources?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type NotificationsInput = {
  /** Product ID to filter notifications. If not provided, all notifications from all products are returned */
  product?: InputMaybe<Scalars["String"]["input"]>;
};

export enum OrderStatus {
  Cancelled = "CANCELLED",
  Failed = "FAILED",
  New = "NEW",
  Pending = "PENDING",
  Refunded = "REFUNDED",
  Success = "SUCCESS",
}

export type PcStreamLaunchData = {
  __typename?: "PCStreamLaunchData";
  /** Bitrate of the launched session */
  bitrate?: Maybe<Scalars["String"]["output"]>;
  /** The server location city */
  city: Scalars["String"]["output"];
  /** The server location country */
  country: Scalars["String"]["output"];
  /** The server date in DD/MM/YYYY format */
  date: Scalars["String"]["output"];
  /**
   * The server date and time in Unix timestamp format localized to server's timezone
   * @deprecated Use time and date fields instead
   */
  datetime?: Maybe<Scalars["Timestamp"]["output"]>;
  /** The URL to launch the game in PC stream mode */
  launchUrl: Scalars["String"]["output"];
  /** The status URL to monitor the stream */
  streamStatusUrl: Scalars["String"]["output"];
  /** The server time in HH:MM:SS AM/PM format */
  time: Scalars["String"]["output"];
};

/** Represents a page group. */
export type PageGroup = {
  __typename?: "PageGroup";
  /** Language-specific assets (image1X, image2X, image3X, video, icon) */
  assets?: Maybe<Scalars["JSON"]["output"]>;
  /** Featured cards belonging to this group on the page */
  cards: Array<FeaturedCard>;
  /** The creation date time of the group */
  createdAt: Scalars["DateTimeISO"]["output"];
  /** Group name (references featured_cards group) */
  group: Scalars["String"]["output"];
  /** Unique identifier for the page group */
  id: Scalars["UUID"]["output"];
  /** Additional metadata (e.g., chargeType, internalProduct) */
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  /** Page on which this group is displayed */
  page: Scalars["String"]["output"];
  /** Ordering position of the group on the page */
  position: Scalars["Int"]["output"];
  /** Language-specific titles */
  title: Scalars["JSON"]["output"];
  /** The updation date time of the group */
  updatedAt: Scalars["DateTimeISO"]["output"];
};

/** Input type for Page */
export type PageInput = {
  /** Language-specific assets (image1X, image2X, image3X, video, icon) */
  assets?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Group name (references featured_cards group) */
  group: Scalars["String"]["input"];
  /** Additional metadata */
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Display position of the group on the page */
  position: Scalars["Int"]["input"];
  /** Language-specific titles */
  title: Scalars["JSON"]["input"];
};

export type PageOutput = PaginatedQueryOutput & {
  __typename?: "PageOutput";
  /** List of groups on the page */
  items: Array<PageGroup>;
  /** Total number of groups */
  total: Scalars["Int"]["output"];
};

/**
 * When query input is not provided, tenantId and productId will be extracted
 * from user's auth context.
 */
export type PageQueryInput = {
  /** Page ID to fetch. */
  page: Scalars["String"]["input"];
  /**
   * Filter by product ID.
   * If not provided, will use product ID from user's auth context.
   * However, if provided, then tenantId must also be provided.
   */
  productId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by tenant ID.
   * If not provided, will use tenant ID from user's auth context.
   * However, if provided, then productId must also be provided.
   */
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type Pageable =
  | Achievement
  | EventRule
  | FeaturedCard
  | FollowRequest
  | Game
  | Inventory
  | LeaderboardUser
  | News
  | PageGroup
  | SubscriptionPlan
  | Tenant
  | Transaction
  | User
  | Voucher;

/** Input for pages query */
export type PagesQueryInput = {
  /** Product ID */
  productId: Scalars["String"]["input"];
  /** Tenant ID */
  tenantId: Scalars["String"]["input"];
};

export type PaginatedQueryInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PaginatedQueryOutput = {
  items: Array<Pageable>;
  total: Scalars["Int"]["output"];
};

export type PathFeaturedCardData = {
  __typename?: "PathFeaturedCardData";
  /** Internal path where the card should redirect to on click */
  internalPath: Scalars["String"]["output"];
};

export enum PaymentGateway {
  Juspay = "JUSPAY",
  Onmopay = "ONMOPAY",
  Razorpay = "RAZORPAY",
}

/** Payment URLs for different client contexts */
export type PaymentUrls = {
  __typename?: "PaymentUrls";
  /** URL for embedding in an iframe */
  iframe?: Maybe<Scalars["String"]["output"]>;
  /** Deep-link or intent URL for mobile apps */
  mobile?: Maybe<Scalars["String"]["output"]>;
  /** URL for web browser redirect flow */
  web: Scalars["String"]["output"];
};

export type PrizePools = {
  __typename?: "PrizePools";
  /** Battle coins payouts */
  battle: BattlePayout;
  /** Casual rewards */
  casual: CasualPayout;
  /**
   * Challenge Rewards
   * @deprecated Challenges feature is no longer supported
   */
  challenge: ChallengeRewards;
  /** Tournament prize pools for all active tournament types */
  tournament: Array<TournamentPrizePool>;
};

export type Product = {
  __typename?: "Product";
  /** Configuration of the product */
  config: Scalars["JSON"]["output"];
  /** Product icon specific to tenant, if exists. */
  icon?: Maybe<Scalars["String"]["output"]>;
  /** ID of the product */
  id: Scalars["String"]["output"];
  /** Name of the product */
  name: Scalars["String"]["output"];
  /** 2-letter unique shortcode for the product */
  shortCode: Scalars["String"]["output"];
  /** Supported game modes for the product */
  supportedGameModes: Array<GamePlayMode>;
  /** Type of the product */
  type: ProductType;
};

export type ProductBrandingInput = {
  /** Icon URL displayed for the product */
  icon: Scalars["String"]["input"];
  /** Title displayed for the product */
  title: Scalars["String"]["input"];
};

export enum ProductType {
  External = "EXTERNAL",
  Internal = "INTERNAL",
}

export type ProductsOutput = {
  __typename?: "ProductsOutput";
  items: Array<Product>;
  total: Scalars["Int"]["output"];
};

export type PurchaseInventoryInput = {
  /** Specify true if the user wants the inventory effect applied on purchase */
  applyImmediately?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** An inventory can have multiple prices, the selected option is specified here (empty when free) */
  inventoryCost?: InputMaybe<InventoryCostInput>;
  /** ID of the inventory being purchased */
  inventoryId: Scalars["UUID"]["input"];
};

export type Query = {
  __typename?: "Query";
  config: Config;
  /** @deprecated Use videos resolver instead */
  contentVideos: Array<VideoItem>;
  /** Fetch the list of available EON cluster domains for the authenticated user's tenant */
  eonClusterDetails: Array<EonClusterDomain>;
  eventRules: Array<EventRule>;
  /** Query featured card groups for a tenant and product. */
  featuredCardGroups: Array<Scalars["String"]["output"]>;
  /** Query tenants that have featured cards defined. Optionally filter by product. */
  featuredCardTenants: Array<Tenant>;
  featuredCards: FeaturedCardOutput;
  followSuggestions: Array<FollowSuggestion>;
  game: Game;
  /** Fetch the installation progress for a game session, if applicable for the game play mode */
  gameInstallationProgress: GameInstallationProgress;
  /** Check the queue status for a game play */
  gameQueueStatus: GameQueueStatusOutput;
  /** Fetch a game session */
  gameSession: GameSession;
  /** Returns suggested games from the search index */
  gameSuggestions: Array<SuggestedGame>;
  games: GamesOutput;
  health: Health;
  inventories: InventoriesOutput;
  /** Get leaderboard */
  leaderboard: Leaderboard;
  /** Available login rewards */
  loginRewards: Array<LoginReward>;
  me: User;
  news: NewsOutput;
  page: PageOutput;
  /** Query tenants that have pages defined. Optionally filter by product. Only accessible by ADMIN and B2B_ADMIN users. */
  pageTenants: Array<Tenant>;
  /** Query Page IDs for a tenant and product. Only accessible by ADMIN and B2B_ADMIN users. */
  pages: Array<Scalars["String"]["output"]>;
  product: Product;
  products: ProductsOutput;
  settings: Array<Setting>;
  subscriptionPlans: SubscriptionPlansOutput;
  tenant: Tenant;
  tenants: TenantsOutput;
  user: User;
  users: UsersOutput;
  videos: Array<VideoItem>;
  /** Retrieve the current Vodabucks balance for a user. Available only for Vodacom users. */
  vodabucksBalance: VodabucksBalance;
  /** List vouchers with filters (Admin/B2B_ADMIN only) */
  vouchers: VouchersOutput;
};

export type QueryContentVideosArgs = {
  params?: InputMaybe<VideoParams>;
  type: VideoType;
};

export type QueryEventRulesArgs = {
  restrictToActive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryFeaturedCardGroupsArgs = {
  input: FeaturedCardGroupsInput;
};

export type QueryFeaturedCardTenantsArgs = {
  productId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryFeaturedCardsArgs = {
  input?: InputMaybe<FeaturedCardQueryInput>;
};

export type QueryGameArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGameInstallationProgressArgs = {
  input: GameSessionInput;
};

export type QueryGameSessionArgs = {
  input: GameSessionInput;
};

export type QueryGameSuggestionsArgs = {
  input: GameSuggestionsInput;
};

export type QueryGamesArgs = {
  input: ListGamesInput;
};

export type QueryInventoriesArgs = {
  input?: InputMaybe<InventoriesInput>;
};

export type QueryLeaderboardArgs = {
  input: LeaderboardInput;
};

export type QueryNewsArgs = {
  input: NewsQueryInput;
};

export type QueryPageArgs = {
  input?: InputMaybe<PageQueryInput>;
};

export type QueryPageTenantsArgs = {
  productId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPagesArgs = {
  input: PagesQueryInput;
};

export type QueryProductArgs = {
  id: Scalars["String"]["input"];
};

export type QueryProductsArgs = {
  input?: InputMaybe<ListProductsInput>;
};

export type QuerySubscriptionPlansArgs = {
  input: ListSubscriptionPlansInput;
};

export type QueryTenantArgs = {
  id: Scalars["String"]["input"];
};

export type QueryTenantsArgs = {
  input?: InputMaybe<ListTenantsInput>;
};

export type QueryUserArgs = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  idpId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryUsersArgs = {
  input: UsersQueryInput;
};

export type QueryVideosArgs = {
  params?: InputMaybe<VideoParams>;
  type: VideoType;
};

export type QueryVodabucksBalanceArgs = {
  input: VodabucksBalanceInput;
};

export type QueryVouchersArgs = {
  input: ListVouchersInput;
};

export enum RankOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type RecentlyPlayedGamesInput = {
  page?: InputMaybe<PaginatedQueryInput>;
  /** Restrict to current product. Default is true */
  restrictToCurrentProduct?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input type for redeeming a voucher code */
export type RedeemVoucherInput = {
  code: Scalars["String"]["input"];
};

export enum RepeatCycle {
  Daily = "daily",
  Monthly = "monthly",
  Weekly = "weekly",
}

export enum RotationMode {
  Any = "ANY",
  Landscape = "LANDSCAPE",
  Portrait = "PORTRAIT",
}

export type SdkPayload = JuspaySdkPayload;

export type Setting = {
  __typename?: "Setting";
  /** Key of the setting */
  key: SettingKey;
  /** Tenant specific overrides of the setting */
  overrides: Array<SettingOverride>;
  /** Global value of the setting */
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum SettingKey {
  AcceptableRangeForHouseBattle = "ACCEPTABLE_RANGE_FOR_HOUSE_BATTLE",
  AdWatchRewardConfig = "AD_WATCH_REWARD_CONFIG",
  AntiCheatEnabled = "ANTI_CHEAT_ENABLED",
  BattleCoinPayouts = "BATTLE_COIN_PAYOUTS",
  BattleRewardCurrency = "BATTLE_REWARD_CURRENCY",
  CasualHtmlConfig = "CASUAL_HTML_CONFIG",
  CasualModeConfig = "CASUAL_MODE_CONFIG",
  CasualStreamConfig = "CASUAL_STREAM_CONFIG",
  ChallengeRewards = "CHALLENGE_REWARDS",
  CityGeolocationData = "CITY_GEOLOCATION_DATA",
  FreeCoins = "FREE_COINS",
  GameQueueSkipActiveCheck = "GAME_QUEUE_SKIP_ACTIVE_CHECK",
  GlobalGameRewardCap = "GLOBAL_GAME_REWARD_CAP",
  HomepageBeatitGames = "HOMEPAGE_BEATIT_GAMES",
  HomepageChallengeGames = "HOMEPAGE_CHALLENGE_GAMES",
  LoginRewards = "LOGIN_REWARDS",
  NewsSourcesAndCategories = "NEWS_SOURCES_AND_CATEGORIES",
  NotificationConfig = "NOTIFICATION_CONFIG",
  OnmopayConfig = "ONMOPAY_CONFIG",
  OnmoSubscriptionEncryptionKey = "ONMO_SUBSCRIPTION_ENCRYPTION_KEY",
  OnmoSubscriptionLinkMsisdn = "ONMO_SUBSCRIPTION_LINK_MSISDN",
  OnmoSubscriptionNextChargeDate = "ONMO_SUBSCRIPTION_NEXT_CHARGE_DATE",
  OnmoSubscriptionResumeParams = "ONMO_SUBSCRIPTION_RESUME_PARAMS",
  OnmoSubscriptionResumePassword = "ONMO_SUBSCRIPTION_RESUME_PASSWORD",
  OnmoSubscriptionResumeUrl = "ONMO_SUBSCRIPTION_RESUME_URL",
  OnmoSubscriptionResumeUsername = "ONMO_SUBSCRIPTION_RESUME_USERNAME",
  OnmoSubscriptionSignaturePassword = "ONMO_SUBSCRIPTION_SIGNATURE_PASSWORD",
  OnmoSubscriptionSignatureUsername = "ONMO_SUBSCRIPTION_SIGNATURE_USERNAME",
  OnmoSubscriptionStatusParams = "ONMO_SUBSCRIPTION_STATUS_PARAMS",
  OnmoSubscriptionStatusUrl = "ONMO_SUBSCRIPTION_STATUS_URL",
  OnmoSubscriptionUserIdField = "ONMO_SUBSCRIPTION_USER_ID_FIELD",
  OnmoSubscriptionUseOpsign = "ONMO_SUBSCRIPTION_USE_OPSIGN",
  OnmoSubscriptionValidateRefid = "ONMO_SUBSCRIPTION_VALIDATE_REFID",
  PoorNetworkNotificationConfig = "POOR_NETWORK_NOTIFICATION_CONFIG",
  StreamingStartBitrate = "STREAMING_START_BITRATE",
  StreamingVendor = "STREAMING_VENDOR",
  StreamingVendorOverflow = "STREAMING_VENDOR_OVERFLOW",
  SubscriptionGatewayConfig = "SUBSCRIPTION_GATEWAY_CONFIG",
  TierLevels = "TIER_LEVELS",
  Timezone = "TIMEZONE",
  VoucherSubscriptionEnabled = "VOUCHER_SUBSCRIPTION_ENABLED",
}

export type SettingOverride = {
  __typename?: "SettingOverride";
  /** Tenants the overriden value applies to */
  tenants: Array<Tenant>;
  /** Overriden value */
  value: Scalars["String"]["output"];
};

export type SettingOverrideInput = {
  /** Tenants the overriden value applies to */
  tenants: Array<Scalars["String"]["input"]>;
  /** Overriden value */
  value: Scalars["String"]["input"];
};

export type SettingUpdateInput = {
  /** Key of the setting */
  key: SettingKey;
  /** Tenant specific overrides of the setting */
  overrides: Array<SettingOverrideInput>;
  /** Global value of the setting */
  value: Scalars["String"]["input"];
};

/** Short URL response */
export type ShortUrl = {
  __typename?: "ShortUrl";
  /** Short URL */
  url: Scalars["String"]["output"];
};

/** Input data to create a short url */
export type ShortUrlInput = {
  /** Custom description for the social preview. Will only be visible when `imagePath` is provided. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Number of days until the short URL expires. Must be between 1 and 30 days. Defaults to 7 days. */
  expiration?: InputMaybe<Scalars["Int"]["input"]>;
  /** Relative path of the preview image in the data S3 bucket to be used for preview while sharing in social apps. Must begin with `/`. */
  imagePath?: InputMaybe<Scalars["String"]["input"]>;
  /** Language being used by the user. ISO 639-1 format e.g. 'en', 'fr' */
  language?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Relative path of the Frontend to create a short url for.
   * Must begin with `/`.
   * E.g. /games/101
   */
  path: Scalars["String"]["input"];
  /** Product ID associated with the short URL */
  productId?: InputMaybe<Scalars["String"]["input"]>;
  /** Custom title for the social preview. Will only be visible when `imagePath` is provided. Defaults to ONMO. */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignedUrl = {
  __typename?: "SignedURL";
  /** The url to get or put objects to S3 */
  url: Scalars["String"]["output"];
};

export type SignedUrlInput = {
  /** Type of the object being uploaded, asset or a file to share */
  bucketType: BucketType;
  /** Content type of the file. ex: image/jpeg */
  contentType: Scalars["String"]["input"];
  /** The path at which the user wants to fetch or upload the file */
  objectPath: Scalars["String"]["input"];
};

export type StartGamePlayInput = {
  /** Game session ID to start the game play */
  gameSessionId: Scalars["UUID"]["input"];
};

export type StartGamePlayOutput = {
  __typename?: "StartGamePlayOutput";
  /** Game session that was started */
  gameSession: GameSession;
  /** Message indicating the result of the start operation */
  message: Scalars["String"]["output"];
};

export enum StreamCodec {
  Av1 = "AV1",
  H264 = "H264",
  H265 = "H265",
}

export type SubscriptionActivationNotificationData = {
  __typename?: "SubscriptionActivationNotificationData";
  /** Tags earned from the subscription plan */
  earnedTags: Array<Scalars["String"]["output"]>;
};

export type SubscriptionBonusEligibleNotificationData = {
  __typename?: "SubscriptionBonusEligibleNotificationData";
  /** Bonus days the user is eligible for */
  bonusDays: Scalars["Int"]["output"];
  /** Tags earned from the subscription plan */
  earnedTags: Array<Scalars["String"]["output"]>;
};

export type SubscriptionPlan = {
  __typename?: "SubscriptionPlan";
  /** Game categories that are allowed for this subscription plan */
  allowedGameCategories?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Plan visual assets */
  assets?: Maybe<Scalars["JSON"]["output"]>;
  /** Creation date */
  createdAt: Scalars["DateTimeISO"]["output"];
  /** Duration of the plan in days */
  duration: Scalars["Int"]["output"];
  /** External identifier for the plan, used for mapping with external systems like payment gateways */
  externalPlanId: Scalars["String"]["output"];
  /** Gateway for this subscription plan (e.g., ONMOPAY, RAZORPAY) */
  gateway?: Maybe<PaymentGateway>;
  /** Unique identifier for the subscription plan (UUID) */
  id: Scalars["UUID"]["output"];
  /** Whether the subscription plan is currently enabled and available for purchase */
  isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Whether vouchers can be created for this plan */
  isVoucherEligible?: Maybe<Scalars["Boolean"]["output"]>;
  /** Item amount for the plan */
  itemAmount?: Maybe<Scalars["Float"]["output"]>;
  /** Item type for the plan (can be CoinType, AchievementType, or custom string) */
  itemType?: Maybe<Scalars["String"]["output"]>;
  /** Label for the plan (contains title, description, features, etc. for different locales) */
  labels?: Maybe<Scalars["JSON"]["output"]>;
  /** Additional plan metadata */
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  /** Amount user pays for the plan */
  planAmount: Scalars["Float"]["output"];
  /** Position of the plan when displayed in a list, used for ordering subscription plans in the UI */
  position: Scalars["Int"]["output"];
  /** Product ID */
  productId: Scalars["String"]["output"];
  /** Plan tags for eligibility checks and grants */
  tags?: Maybe<SubscriptionPlanTags>;
  /** Tenant ID */
  tenantId: Scalars["String"]["output"];
  /** Last update date */
  updatedAt: Scalars["DateTimeISO"]["output"];
  /** Wallet type for the plan */
  walletType?: Maybe<WalletType>;
};

/** Input type for creating or updating subscription plans. If 'id' is provided, the existing plan will be updated; if not, a new plan will be created. */
export type SubscriptionPlanInput = {
  /** Game categories that are allowed for this subscription plan. If not provided, there will be no restrictions on game categories for this plan. */
  allowedGameCategories?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Plan visual assets */
  assets?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Duration of the plan in days */
  duration: Scalars["Int"]["input"];
  /** External identifier for the plan, used for mapping with external systems like payment gateways */
  externalPlanId: Scalars["String"]["input"];
  /** Gateway for this subscription plan (e.g., ONMOPAY, RAZORPAY) */
  gateway?: InputMaybe<PaymentGateway>;
  /** ID of the plan (UUID, optional for new plans, required for updates) */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Whether the subscription plan is currently enabled and available for purchase */
  isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Whether vouchers can be created for this plan */
  isVoucherEligible?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Item amount for the plan */
  itemAmount?: InputMaybe<Scalars["Float"]["input"]>;
  /** Item type for the plan (can be CoinType, AchievementType, or custom string). If not provided, it will default to basic. */
  itemType?: InputMaybe<Scalars["String"]["input"]>;
  /** Label for the plan (contains title, description, features, etc. for different locales) */
  labels?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Additional plan metadata */
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Amount for the plan */
  planAmount: Scalars["Float"]["input"];
  /** Position of the plan when displayed in a list */
  position: Scalars["Int"]["input"];
  /** Plan tags for eligibility checks and grants */
  tags?: InputMaybe<SubscriptionPlanTagsInput>;
  /** Wallet type for the plan. If not provided, it will default to coin. */
  walletType?: InputMaybe<WalletType>;
};

export type SubscriptionPlanTags = {
  __typename?: "SubscriptionPlanTags";
  /** Tags required for a user to be eligible for this plan (user must have ALL of them) */
  eligibilityTags?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Tags granted to the user upon subscribing to this plan */
  grantTags?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type SubscriptionPlanTagsInput = {
  /** Tags required for a user to be eligible for this plan (user must have ALL of them) */
  eligibilityTags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Tags granted to the user upon subscribing to this plan */
  grantTags?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type SubscriptionPlansOutput = {
  __typename?: "SubscriptionPlansOutput";
  items: Array<SubscriptionPlan>;
  total: Scalars["Int"]["output"];
};

/** Product details associated with a subscription, sourced from tenant configuration. */
export type SubscriptionProduct = {
  __typename?: "SubscriptionProduct";
  /** Icon URL of the product */
  icon: Scalars["String"]["output"];
  /** Product ID */
  id: Scalars["String"]["output"];
  /** Title of the product */
  title: Scalars["String"]["output"];
};

export type SuggestedGame = {
  __typename?: "SuggestedGame";
  id: Scalars["String"]["output"];
  labels: Array<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export type Tenant = {
  __typename?: "Tenant";
  /**
   * Overridden Game IDs.
   * Based on the gameOverrideMode, these games will be included or excluded for a tenant
   * @deprecated Use overriddenGames field instead
   */
  gameOverrideIds?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * Game Override type.
   * INCLUDE refers to enabled games.
   * EXCLUDE refers to disabled games.
   * null means no override.
   */
  gameOverrideMode?: Maybe<GameOverrideMode>;
  /** Id of the tenant set */
  id: Scalars["String"]["output"];
  /** Default language code of the tenant */
  languageCode: Scalars["String"]["output"];
  /** Additional metadata for the tenant */
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  /** Name of the tenant */
  name: Scalars["String"]["output"];
  /** Overridden Games subresolver. */
  overriddenGames?: Maybe<Array<Game>>;
  /** Enabled products for the tenant */
  products: Array<TenantProductConfig>;
  /** Short name for the tenant */
  shortCode: Scalars["String"]["output"];
  /** Tenant status which denotes, if tenant is live or is disabled */
  status: TenantStatus;
};

export type TenantProductConfig = {
  __typename?: "TenantProductConfig";
  /** App URL for the tenant's product */
  appUrl: Scalars["String"]["output"];
  /** Enabled game modes for the tenant's product */
  enabledGameModes: Array<GamePlayMode>;
  /** Product ID */
  id: Scalars["String"]["output"];
};

export type TenantProductConfigInput = {
  appUrl: Scalars["String"]["input"];
  enabledGameModes: Array<GamePlayMode>;
  id: Scalars["String"]["input"];
  productBranding?: InputMaybe<ProductBrandingInput>;
};

export enum TenantStatus {
  Disabled = "DISABLED",
  Live = "LIVE",
}

export type TenantsOutput = PaginatedQueryOutput & {
  __typename?: "TenantsOutput";
  items: Array<Tenant>;
  total: Scalars["Int"]["output"];
};

/** Test Login Token response */
export type TestLoginUrl = {
  __typename?: "TestLoginUrl";
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Input for generating a test login token */
export type TestLoginUrlInput = {
  product: Scalars["String"]["input"];
  tenantId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type ThumbnailUrl = {
  __typename?: "ThumbnailUrl";
  default?: Maybe<Scalars["String"]["output"]>;
  high?: Maybe<Scalars["String"]["output"]>;
  medium?: Maybe<Scalars["String"]["output"]>;
};

/** Denotes a Tier Level. */
export type TierLevel = {
  __typename?: "TierLevel";
  /** Amount of the tier level */
  amount: Scalars["Int"]["output"];
  /** ID of the tier level. */
  levelId: Scalars["String"]["output"];
};

export enum TimeFrame {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export type Tournament = {
  __typename?: "Tournament";
  /** Game for which tournament is being run */
  game: Game;
  /** Tournament ID */
  id: Scalars["String"]["output"];
  /** Current tournament status */
  status: TournamentStatus;
};

export type TournamentDefinition = {
  __typename?: "TournamentDefinition";
  /** Games for which tournament will be created */
  games: Array<Game>;
  /** Definition ID */
  id: Scalars["String"]["output"];
};

export type TournamentFeaturedCardData = {
  __typename?: "TournamentFeaturedCardData";
  /** Tournament Definition data */
  tournamentDefinition: TournamentDefinition;
  /** List of active tournaments associated with the tournament definition */
  tournaments: Array<Tournament>;
};

/** Tournament type detail with prize pool configuration */
export type TournamentPrizePool = {
  __typename?: "TournamentPrizePool";
  /** Currency type for this tournament's prizes */
  coinType: CoinType;
  /** Tournament type detail ID */
  id: Scalars["ID"]["output"];
  /** Prize pool distribution by rank */
  prizePool: Array<TournamentPrizePoolEntry>;
};

/** Prize pool entry for tournament payouts */
export type TournamentPrizePoolEntry = {
  __typename?: "TournamentPrizePoolEntry";
  /** Prize amount for the rank */
  prize: Scalars["Int"]["output"];
  /** All ranks equal to or better than this rank will get this prize amount */
  toRank: Scalars["Int"]["output"];
};

export enum TournamentStatus {
  Cancelled = "CANCELLED",
  Closed = "CLOSED",
  Completed = "COMPLETED",
  Open = "OPEN",
  Reviewed = "REVIEWED",
}

/** Data for tournament notifications */
export type TournamentUserNotificationData = {
  __typename?: "TournamentUserNotificationData";
  /** User that replaced the notification's recipient in the tournament */
  demotingUser?: Maybe<User>;
  /** GAME ID */
  gameId: Scalars["String"]["output"];
  /** Rank of the user in that tournament. */
  rank: Scalars["Int"]["output"];
  /** TOURNAMENT ID */
  tournamentId: Scalars["UUID"]["output"];
};

/** For tracking activities */
export type TrackActivityInput = {
  activityType: ActivityType;
  avatar?: InputMaybe<Scalars["String"]["input"]>;
  battleId?: InputMaybe<Scalars["String"]["input"]>;
  battleType?: InputMaybe<BattleType>;
  bonusDays?: InputMaybe<Scalars["Int"]["input"]>;
  disable?: InputMaybe<Scalars["Boolean"]["input"]>;
  earnedTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  followerUserId?: InputMaybe<Scalars["String"]["input"]>;
  gameId?: InputMaybe<Scalars["String"]["input"]>;
  isCommon?: InputMaybe<Scalars["Boolean"]["input"]>;
  isEndScreenReward?: InputMaybe<Scalars["Boolean"]["input"]>;
  momentId?: InputMaybe<Scalars["String"]["input"]>;
  opponentIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  orderId?: InputMaybe<Scalars["String"]["input"]>;
  prizeAmount?: InputMaybe<Scalars["Int"]["input"]>;
  /** prizeCoinType combines enum CoinType and AchievementType, which GraphQL doesn't support—validation is handled in the resolver. */
  prizeCoinType?: InputMaybe<Scalars["String"]["input"]>;
  product?: InputMaybe<Scalars["String"]["input"]>;
  rank?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
  walletType?: InputMaybe<WalletType>;
  winner?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Denotes a transaction. */
export type Transaction = {
  __typename?: "Transaction";
  /** Amount credited or debited to/from the user's wallet. */
  amount: Scalars["Float"]["output"];
  /** Coin type of the transaction. says gems or basic */
  coinType: CoinType;
  /** Date on which the transaction occurred */
  date: Scalars["DateTimeISO"]["output"];
  /** Date and time at which coins credited from the transaction will expire. All debit transaction will have value as `null` except for `EXPIRED` ones */
  expiryDate?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /** Game data if the transaction was performed in relation to a game */
  game?: Maybe<Game>;
  /** Entry ID for the transaction. */
  id: Scalars["UUID"]["output"];
  /** Date and time at which expired coins were received. Will be available only for type `expired` */
  receivedOn?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /** Reference identifier of the transaction. E.g., for battles and tournaments it would be the battle id */
  referenceId?: Maybe<Scalars["String"]["output"]>;
  /** Transaction type of the category */
  type: TransactionType;
};

/** Denotes the type of the transaction */
export enum TransactionType {
  AchievementReward = "achievement_reward",
  Battle = "battle",
  Bonus = "bonus",
  Challenge = "challenge",
  Expired = "expired",
  Free = "free",
  Inventory = "inventory",
  LoginReward = "login_reward",
  Manual = "manual",
  Other = "other",
  Subscription = "subscription",
  Topup = "topup",
  Tournament = "tournament",
  Welcome = "welcome",
}

/** Output from coinTransactions */
export type Transactions = PaginatedQueryOutput & {
  __typename?: "Transactions";
  /** A list of transactions */
  items: Array<Transaction>;
  /** Total count of results */
  total: Scalars["Int"]["output"];
};

/** Filters for fetching transactions. */
export type TransactionsInput = {
  /** Type of wallet to get transactions of. */
  coinTypes?: InputMaybe<Array<CoinType>>;
  /** End date to get transactions till. */
  endDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  /** Pagination input */
  page?: InputMaybe<PaginatedQueryInput>;
  /** Start date to get transactions from. */
  startDate?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
  /** Types of transaction. */
  transactionTypes?: InputMaybe<Array<TransactionType>>;
};

export type UpdateEventRuleInput = {
  active: Scalars["Boolean"]["input"];
  filters?: InputMaybe<Scalars["JSONObject"]["input"]>;
  parameters?: InputMaybe<Scalars["JSONObject"]["input"]>;
  synchronous: Scalars["Boolean"]["input"];
};

/** Input for updating featured cards. */
export type UpdateFeaturedCardsInput = {
  /** List of featured cards to be updated */
  cards: Array<FeaturedCardInput>;
  /** Group for the featured cards. */
  group: Scalars["String"]["input"];
  /** Products associated with the featured cards. */
  productId: Scalars["String"]["input"];
  /** Tenant ID */
  tenantId: Scalars["String"]["input"];
};

/** Input for updating pages. */
export type UpdatePagesInput = {
  /** List of pages to be updated */
  groups: Array<PageInput>;
  /** Page on which these groups are displayed. */
  page: Scalars["String"]["input"];
  /** Product ID */
  productId: Scalars["String"]["input"];
  /** Tenant ID */
  tenantId: Scalars["String"]["input"];
};

export type UpdateProductInput = {
  /** Configuration of the product */
  config?: InputMaybe<Scalars["JSON"]["input"]>;
  /** ID of the product to be updated */
  id: Scalars["String"]["input"];
  /** Name of the product */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** 2-letter unique shortcode for the product */
  shortCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Supported game modes for the product */
  supportedGameModes?: InputMaybe<Array<GamePlayMode>>;
  /** Type of the product */
  type?: InputMaybe<ProductType>;
};

export type UpdateSubscriptionPlansInput = {
  /** List of subscription plans to update */
  plans: Array<SubscriptionPlanInput>;
  /** Product ID for all plans */
  productId: Scalars["String"]["input"];
  /** Tenant ID for all plans */
  tenantId: Scalars["String"]["input"];
};

export type UpdateTenantInput = {
  /** Overridden Game IDs */
  gameOverrideIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Game Override type */
  gameOverrideMode?: InputMaybe<GameOverrideMode>;
  /** ID of the tenant to be updated */
  id: Scalars["String"]["input"];
  /** Default language code of the tenant. */
  languageCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Additional metadata for the tenant */
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /**
   * Name of the tenant
   * Recommended Format: `FriendlyTenantName FriendlyCountryName`
   * Example: `Dialog Sri Lanka`
   */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Enabled products for the tenant */
  products?: InputMaybe<Array<TenantProductConfigInput>>;
  /**
   * Short name for the tenant
   * - Restricted to 3 characters
   * - Example: `dgl`, `vil`, etc.
   */
  shortCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Tenant status which indicates if tenant is live or is disabled. */
  status?: InputMaybe<TenantStatus>;
};

/** Input item for updating voucher details */
export type UpdateVouchersInput = {
  /** Batch ID to update all vouchers in a batch (exactly one of codes, serialNumbers, or batchId is required) */
  batchId?: InputMaybe<Scalars["String"]["input"]>;
  /** Voucher codes to update (exactly one of codes, serialNumbers, or batchId is required) */
  codes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Updated metadata */
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  /** New plan ID (plan must be voucher-eligible) */
  planId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Serial numbers to update (exactly one of codes, serialNumbers, or batchId is required) */
  serialNumbers?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** New status for the voucher (ACTIVE <-> DISABLED only) */
  status?: InputMaybe<VoucherStatus>;
  /** New expiration date (must be in the future) */
  validUntil?: InputMaybe<Scalars["DateTimeISO"]["input"]>;
};

/** Result of update vouchers */
export type UpdateVouchersOutput = {
  __typename?: "UpdateVouchersOutput";
  /** Identifiers (codes or serial numbers) of vouchers skipped because they were already redeemed */
  skippedVoucherIds: Array<Scalars["String"]["output"]>;
  /** Number of vouchers successfully updated */
  updatedCount: Scalars["Int"]["output"];
};

export type User = {
  __typename?: "User";
  /** User's achievements */
  achievements: AchievementsOutput;
  /** User's recent activities */
  activities: ActivityOutput;
  /**
   * User's all-time leaderboard rank
   * @deprecated Use `leaderboardRank` instead
   */
  allTimeRank?: Maybe<Scalars["Int"]["output"]>;
  /** Avatar set for the user */
  avatar: Scalars["String"]["output"];
  /** Banner of the user */
  banner: Scalars["String"]["output"];
  /** Battle streak data of the user */
  battleStreak: BattleStreak;
  /** Number of challenges completed by the user */
  challengesCompleted: Scalars["Int"]["output"];
  /** User's coin wallets */
  coinWallets: Array<CoinWallet>;
  /** Date and time at which user was created */
  createdAt: Scalars["DateTimeISO"]["output"];
  /** User's account status */
  disabled: Scalars["Boolean"]["output"];
  /** User's email address */
  email?: Maybe<Scalars["String"]["output"]>;
  /** User's linked eon accounts */
  eonLinkedAccounts: Array<EonLinkedAccount>;
  /** Facebook's idp id */
  facebookId?: Maybe<Scalars["String"]["output"]>;
  /** User's follow status */
  followStatus: FollowStatus;
  /** User's followers */
  followers: FollowUsersOutput;
  /** User's following */
  following: FollowUsersOutput;
  /** Google's idp Id */
  googleId?: Maybe<Scalars["String"]["output"]>;
  /** ID of the user */
  id: Scalars["UUID"]["output"];
  /** Common IDP ID of the user. `null` when user signed up using phone or email */
  idpId?: Maybe<Scalars["String"]["output"]>;
  /** IDP Provider Name. `null` when user signed up using phone or email */
  idpName?: Maybe<Scalars["String"]["output"]>;
  /** User's inventories */
  inventories: InventoriesOutput;
  /** Whether the authenticated user can initiate a friend battle with this user. True when both users share the same tenant. */
  isFriendBattleAllowed: Scalars["Boolean"]["output"];
  /** User's desired language */
  language?: Maybe<Scalars["String"]["output"]>;
  /** User's last active time and ip address */
  lastActive?: Maybe<LastActive>;
  /** User's last active game session */
  lastActiveGameSession?: Maybe<GameSession>;
  /**
   * Global leaderboard rank of the user.
   * By default returns all-time rank. Use `type` argument to specify the type of leaderboard.
   * Null when user has no rank in the specified leaderboard or leaderboard is not found/started.
   */
  leaderboardRank?: Maybe<Scalars["Int"]["output"]>;
  /** Login streak of the user */
  loginStreak: Scalars["Int"]["output"];
  /** Number of battles/matches played by the user */
  matchesPlayed: Scalars["Int"]["output"];
  /** Number of battles/matches won by the user */
  matchesWon: Scalars["Int"]["output"];
  /** User's metadata */
  metadata?: Maybe<UserMetadata>;
  /** User's notifications */
  notifications: Array<UserNotification>;
  /** User's phone number */
  phone?: Maybe<Scalars["String"]["output"]>;
  /** User's push subscription endpoint */
  pushSubscription?: Maybe<Scalars["String"]["output"]>;
  /** List of recently played games by the user */
  recentlyPlayedGames: Array<Game>;
  /** User's subscription details */
  subscription?: Maybe<UserSubscription>;
  /** User's subscription details for all active products */
  subscriptions: Array<UserSubscription>;
  /** User's tenant ID */
  tenantId: Scalars["String"]["output"];
  /** Number of games played by the user */
  totalPlayedGames: Scalars["Int"]["output"];
  /** Time spent playing games by the user in seconds */
  totalTimePlayed: Scalars["Int"]["output"];
  /** User's transaction */
  transactions: Transactions;
  /** Username of the user */
  username: Scalars["String"]["output"];
  /** user's xp value */
  xp: Scalars["Int"]["output"];
};

export type UserActivitiesArgs = {
  input?: InputMaybe<ActivitiesInput>;
};

export type UserFollowersArgs = {
  input?: InputMaybe<FollowUsersInput>;
};

export type UserFollowingArgs = {
  input?: InputMaybe<FollowUsersInput>;
};

export type UserInventoriesArgs = {
  input?: InputMaybe<InventoriesInput>;
};

export type UserLeaderboardRankArgs = {
  type?: InputMaybe<GlobalLeaderboardType>;
};

export type UserNotificationsArgs = {
  input?: InputMaybe<NotificationsInput>;
};

export type UserRecentlyPlayedGamesArgs = {
  input?: InputMaybe<RecentlyPlayedGamesInput>;
};

export type UserTransactionsArgs = {
  input?: InputMaybe<TransactionsInput>;
};

export enum UserContentType {
  Article = "article",
  Video = "video",
}

export type UserLeaderboardActivityData = {
  __typename?: "UserLeaderboardActivityData";
  endDate: Scalars["DateTimeISO"]["output"];
  leaderboardId: Scalars["String"]["output"];
  leaderboardRank: Scalars["Int"]["output"];
  repeatCycle: RepeatCycle;
  score: Scalars["Int"]["output"];
};

export type UserMetadata = {
  __typename?: "UserMetadata";
  billingInfo?: Maybe<BillingInfo>;
  desiredStreamResolution?: Maybe<Scalars["Int"]["output"]>;
  hasReceivedWelcomeCoins: Scalars["Boolean"]["output"];
  hasSeenWelcomePopup: Scalars["Boolean"]["output"];
  lastSeenTransactionId?: Maybe<Scalars["String"]["output"]>;
  onboarding?: Maybe<Scalars["String"]["output"]>;
  tags?: Maybe<Array<Scalars["String"]["output"]>>;
  tgpLikedItems?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  tgpRecentlyPlayedItems?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type UserMetadataInput = {
  billingInfo?: InputMaybe<BillingInfoInput>;
  desiredStreamResolution?: InputMaybe<Scalars["Int"]["input"]>;
  hasReceivedWelcomeCoins?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasSeenWelcomePopup?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastSeenTransactionId?: InputMaybe<Scalars["String"]["input"]>;
  onboarding?: InputMaybe<Scalars["String"]["input"]>;
  /** Admin-only: tags to assign to the user (e.g. eligibility tags for restricted plans) */
  tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  tgpLikedItems?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tgpRecentlyPlayedItems?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
};

/** Denotes a user Notification. */
export type UserNotification = {
  __typename?: "UserNotification";
  /** Date and time at which the notification was created */
  createdAt?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /** Details about the notification. Format is based on notification type */
  data: UserNotificationData;
  /** Notification ID */
  id: Scalars["UUID"]["output"];
  /** Notification Type */
  type: UserNotificationType;
};

/** Possible format of notification data depending on the notification type */
export type UserNotificationData =
  | AchievementUserNotificationData
  | BattleUserNotificationData
  | FollowUserNotificationData
  | LeaderboardUserNotificationData
  | SubscriptionActivationNotificationData
  | SubscriptionBonusEligibleNotificationData
  | TournamentUserNotificationData;

/** Denotes the type of a notification. */
export enum UserNotificationType {
  AchievementReward = "ACHIEVEMENT_REWARD",
  BattleExpired = "BATTLE_EXPIRED",
  BattleExpiring = "BATTLE_EXPIRING",
  BattleInvitation = "BATTLE_INVITATION",
  BattleLost = "BATTLE_LOST",
  BattleWon = "BATTLE_WON",
  FollowedByUser = "FOLLOWED_BY_USER",
  GlobalLeaderboardEnded = "GLOBAL_LEADERBOARD_ENDED",
  GlobalLeaderboardMonthlyReminder = "GLOBAL_LEADERBOARD_MONTHLY_REMINDER",
  GlobalLeaderboardWeeklyReminder = "GLOBAL_LEADERBOARD_WEEKLY_REMINDER",
  SubscriptionActivated = "SUBSCRIPTION_ACTIVATED",
  SubscriptionBonusGranted = "SUBSCRIPTION_BONUS_GRANTED",
  TournamentCompletion = "TOURNAMENT_COMPLETION",
  TournamentDemotion = "TOURNAMENT_DEMOTION",
}

/** Denotes user subscription details. */
export type UserSubscription = {
  __typename?: "UserSubscription";
  /** Whether the subscription is recurring */
  isRecurring?: Maybe<Scalars["Boolean"]["output"]>;
  /** URL for managing user subscription. */
  managementUrl?: Maybe<Scalars["String"]["output"]>;
  /** Subscription plan details, resolved from planId */
  plan?: Maybe<SubscriptionPlan>;
  /**
   * Plan ID associated with the subscription, if applicable
   * @deprecated Use plan field instead
   */
  planId?: Maybe<Scalars["UUID"]["output"]>;
  /** Product details from tenant subscription config */
  product?: Maybe<SubscriptionProduct>;
  /** Product ID associated with the subscription */
  productId: Scalars["String"]["output"];
  /** OnmoPay subscription redirect URL to subscribe or unsubscribe. */
  redirectUrl?: Maybe<Scalars["String"]["output"]>;
  /** Subscription renewal date. */
  renewalDate?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /** Subscription status */
  status: UserSubscriptionStatus;
  /** OnmoPay top-up redirect URL. Available when user is subscribed and top-up is enabled for tenant and product. */
  topUpUrl?: Maybe<Scalars["String"]["output"]>;
  /** Subscription type indicating how the subscription was created */
  type?: Maybe<UserSubscriptionType>;
  /** Subscription valid until */
  validUntil?: Maybe<Scalars["DateTimeISO"]["output"]>;
};

export enum UserSubscriptionStatus {
  Cancelled = "cancelled",
  Expired = "expired",
  Grace = "grace",
  NotSubscribed = "not_subscribed",
  Pending = "pending",
  Subscribed = "subscribed",
}

export enum UserSubscriptionType {
  Autopay = "AUTOPAY",
  Onetime = "ONETIME",
  Voucher = "VOUCHER",
}

export type UserUpdateInput = {
  /** Banner to be set for user */
  banner?: InputMaybe<Scalars["String"]["input"]>;
  /** To disable or enable the user. When value is `true` other fields cannot be used */
  disable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** ID of the user to be updated. The field is only required when user update is being performed by ADMINs */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** To set the desired language by the user */
  language?: InputMaybe<Scalars["String"]["input"]>;
  /** To set push subscription value for the user */
  pushSubscription?: InputMaybe<Scalars["String"]["input"]>;
  /** To move user to different tenant. Cannot be used with other update fields */
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
  /** New username for the user */
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type UsersOutput = PaginatedQueryOutput & {
  __typename?: "UsersOutput";
  items: Array<User>;
  total: Scalars["Int"]["output"];
};

export type UsersQueryInput = {
  /** Disable status of the user */
  disabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Email of the user */
  email?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<PaginatedQueryInput>;
  /** Tenant ID of the user */
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
  /** Username of the user */
  username?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for verifying a purchase after the user completes the checkout on the payment gateway. This step validates the gateway's signature and activates the subscription or fulfills the purchase accordingly. */
export type VerifyPurchaseInput = {
  /** Gateway's order/session ID received in the checkout callback */
  orderId: Scalars["String"]["input"];
};

/** Result type returned after verifying a purchase. */
export type VerifyPurchaseResult = {
  __typename?: "VerifyPurchaseResult";
  /** Payment gateway that handled this order */
  gateway: PaymentGateway;
  /** Mandate status, present only for recurring subscription orders */
  mandateStatus?: Maybe<MandateStatus>;
  /** Gateway's order/session ID */
  orderId: Scalars["String"]["output"];
  /** Current order status */
  status: OrderStatus;
};

export type VideoItem = {
  __typename?: "VideoItem";
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  publishedAt: Scalars["String"]["output"];
  thumbnailUrl: ThumbnailUrl;
  title: Scalars["String"]["output"];
};

export type VideoParams = {
  channelIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  maxResults?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum VideoType {
  Twitch = "TWITCH",
  Youtube = "YOUTUBE",
}

export type ViewContentInput = {
  contentType: UserContentType;
};

export type ViewContentOutput = {
  __typename?: "ViewContentOutput";
  contentId: Scalars["UUID"]["output"];
};

export type VodabucksBalance = {
  __typename?: "VodabucksBalance";
  /** Current Vodabucks balance for the user */
  balance: Scalars["Int"]["output"];
};

export type VodabucksBalanceInput = {
  /** User ID to retrieve Vodabucks balance for */
  userId: Scalars["UUID"]["input"];
};

/** Complete voucher information */
export type Voucher = {
  __typename?: "Voucher";
  /** Batch identifier for bulk operations */
  batchId?: Maybe<Scalars["String"]["output"]>;
  /** Unique voucher code (without dashes: XXXXXXXXXXXX) */
  code: Scalars["String"]["output"];
  /** Creation timestamp */
  createdAt: Scalars["DateTimeISO"]["output"];
  /** Voucher code for display (with dashes: XXXX-XXXX-XXXX) */
  displayCode: Scalars["String"]["output"];
  /** Voucher UUID */
  id: Scalars["ID"]["output"];
  /** Additional metadata */
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  /** Subscription plan ID this voucher grants access to */
  planId: Scalars["UUID"]["output"];
  /** When the voucher was redeemed (null = not redeemed) */
  redeemedAt?: Maybe<Scalars["DateTimeISO"]["output"]>;
  /** Serial number of controller to which the code is mapped */
  serialNumber?: Maybe<Scalars["String"]["output"]>;
  /** Voucher status */
  status: VoucherStatus;
  /** Last update timestamp */
  updatedAt: Scalars["DateTimeISO"]["output"];
  /** Expiration date for redemption (null = no expiry) */
  validUntil?: Maybe<Scalars["DateTimeISO"]["output"]>;
};

/** Voucher status */
export enum VoucherStatus {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  Redeemed = "REDEEMED",
}

/** Paginated list of vouchers */
export type VouchersOutput = PaginatedQueryOutput & {
  __typename?: "VouchersOutput";
  /** List of vouchers */
  items: Array<Voucher>;
  /** Total count matching the filters */
  total: Scalars["Int"]["output"];
};

export enum WalletType {
  Achievement = "achievement",
  Coin = "coin",
  Inventory = "inventory",
}
